// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --p: 0;
  --b: 2px;
  --c: var(--red);
  --w: 16px;
}

.nav-link.cta-btn:hover,
.nav-link.cta-btn.active {
  background: var(--darkSlate);
  color: var(--white);
}

.modal-backdrop {
  display: none;
}

body.header-popup-open .content-wrapper,
body.header-popup-open .prediction-market-page,
body.header-popup-open .prediction-market-layout {
  pointer-events: none;
}

header.header.header-popup-open {
  z-index: 2100;
  pointer-events: auto;
}

header {
  position: relative;
  z-index: 11;
  top: 0;
  width: 100%;
  min-height: 55px;
  left: 0;
  right: 0;
}
header .header-content {
  max-width: 1400px;
  margin: 0 auto;
}
@media screen and (max-width: 575.98px) {
  header {
    min-height: 64px;
  }
}
header .brand-logo img {
  height: 50px;
}
header .brand-logo svg {
  width: 158px;
}
@media screen and (max-width: 1199.98px) {
  header .brand-logo svg {
    width: 50px;
    height: 50px;
  }
}
@media screen and (max-width: 768px) {
  header .brand-logo svg {
    width: 40px;
    height: 40px;
  }
}
header .brand-logo .before-login-logo {
  width: 158px !important;
}
header .header-middle-btn {
  gap: 0.5rem;
  position: absolute;
  transform: translate(-50%, -50%);
  left: 50%;
  top: 50%;
}
header .header-middle-btn .cashier-btn {
  background: linear-gradient(#EFD43C, #CB7D00);
}
@media screen and (max-width: 768px) {
  header .header-middle-btn {
    position: static;
    transform: none;
  }
}
@media screen and (max-width: 575.98px) {
  header .header-middle-btn {
    margin-left: auto;
  }
}
header .header-middle-btn .btn-primary {
  background: var(--gray-80);
  border-color: var(--gray-80);
  display: flex;
  align-items: center;
  justify-content: center;
}
header .header-middle-btn .btn-primary:hover {
  background: var(--sidebarBtnGradient);
  border: 1px solid var(--gray-60);
}
header .header-middle-btn .btn-primary.currencies-btn {
  background: var(--darkGray);
  border: none;
  border-radius: 0.5rem;
  min-height: 2.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
}
header .header-middle-btn .btn-primary.currencies-btn::after {
  display: none;
}
header .header-middle-btn .btn-primary.currencies-btn:hover {
  background: var(--gray-80) !important;
  border-radius: 0.5rem;
}
@media screen and (max-width: 1400px) {
  header .header-middle-btn .btn-primary.currencies-btn {
    border-radius: 6px 0 0 6px;
  }
  header .header-middle-btn .btn-primary.currencies-btn:hover {
    border-radius: 6px 0 0 6px;
  }
}
@media screen and (max-width: 575.98px) {
  header .header-middle-btn .btn-primary.currencies-btn {
    padding: 0.25rem 0.5rem;
    min-height: 2.5rem;
  }
}
header .header-middle-btn .buy-crypto {
  color: var(--gray-20);
  background-color: var(--gray-80-50);
  border: none;
}
header .header-middle-btn .buy-crypto:hover {
  color: var(--white);
  border: none;
}
header .header-social-links a {
  height: 2.75rem;
  width: 2.75rem;
  border-radius: 0.625rem;
  background: var(--gray-80);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: background-color 0.3s ease 0s;
}
header .header-social-links a svg {
  transition: fill 0.3s ease 0s;
}
header .header-social-links a:not(:last-child) {
  margin-right: 0.5rem;
}
header .header-social-links a:hover {
  background: var(--gray-60);
}
header .header-social-links a:hover svg {
  fill: var(--blue-300);
}
@media only screen and (min-width: 768px) and (max-width: 1480.98px) {
  header.sidebar-close .brand-logo {
    margin-left: 0;
  }
}
header .auth-btn.btn-primary {
  min-width: 120px;
  background: linear-gradient(#EFD43C, #CB7D00);
  color: #ffffff;
}
header .auth-btn.btn-primary:hover {
  background: linear-gradient(#EFD43C, #CB7D00) !important;
  border-color: #CB7D00;
}
@media screen and (max-width: 991.98px) {
  header .auth-btn.btn-primary {
    font-size: 0.875rem;
  }
}
@media screen and (max-width: 767.98px) {
  header .auth-btn.btn-primary {
    min-width: 106px;
    font-size: 1rem;
    min-height: 2.5rem;
  }
}
@media screen and (max-width: 575.98px) {
  header .auth-btn.btn-primary {
    min-height: 2rem;
    font-size: 14px;
    line-height: 1rem;
    min-width: auto;
    padding: 8px 12px;
  }
}
header .auth-btn.btn-secondary {
  min-width: 120px;
  color: #EFD43C;
  background: transparent;
  border: 1px solid #CB7D00;
}
@media screen and (max-width: 991.98px) {
  header .auth-btn.btn-secondary {
    font-size: 0.875rem;
  }
}
@media screen and (max-width: 767.98px) {
  header .auth-btn.btn-secondary {
    min-width: 106px;
    font-size: 1rem;
    min-height: 2.5rem;
  }
}
@media screen and (max-width: 575.98px) {
  header .auth-btn.btn-secondary {
    min-height: 2rem;
    font-size: 14px;
    line-height: 1rem;
    min-width: auto;
    padding: 8px 12px;
  }
}
header .search-btn {
  width: 45px;
  align-items: center;
  justify-content: center;
  padding: 0;
}
header .search-btn svg {
  height: 1.2rem;
  width: 1.2rem;
}
header .search-btn.btn-primary {
  background: var(--gray-80);
  border-color: var(--gray-80);
  position: relative;
}
header .search-btn .theme-modal .modal-dialog {
  position: relative;
}
header .reward-menu-wrap .reward-menu {
  min-width: 415px;
  left: -60% !important;
  overflow-x: hidden;
  overflow-y: auto;
  min-height: 310px;
  padding: 1.5rem 1.5rem 0 1.5rem;
  margin-bottom: 0;
}
@media screen and (max-width: 767.98px) {
  header .reward-menu-wrap .reward-menu {
    min-width: 360px;
  }
}
header .reward-menu-wrap .reward-menu li {
  margin-bottom: 0.75rem;
}
header .reward-menu-wrap .reward-menu li:last-child {
  margin-bottom: 0;
}
header .reward-menu-wrap .reward-menu .dropdown-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  padding: 0.313rem 0;
}
header .reward-menu-wrap .reward-menu .dropdown-item:hover {
  background: transparent;
}
header .reward-menu-wrap .reward-menu .dropdown-item:hover img {
  filter: none;
}
header .reward-menu-wrap .reward-menu .dropdown-item .reward-menu-content h4 {
  font-size: 0.875rem;
  text-transform: uppercase;
  padding-bottom: 0.1rem;
}
header .reward-menu-wrap .reward-menu .dropdown-item .reward-menu-content p {
  font-size: 0.75rem;
  font-weight: 300;
  color: var(--live-green);
}
header .reward-menu-wrap .reward-menu .dropdown-item .btn {
  height: auto;
  padding: 0.2rem 1rem;
  font-size: 0.75rem;
}
header .reward-menu-wrap .reward-menu .dropdown-item .btn svg {
  width: 1rem;
  height: 1rem;
  margin-right: 0.313rem;
}
header .reward-menu-wrap .reward-menu .dropdown-item .btn.btn-green {
  background: var(--live-green);
}
header .reward-menu-wrap .reward-menu .dropdown-item .btn.btn-green:hover {
  background: transparent;
  border-color: var(--blue-300);
}
header .reward-menu-wrap .reward-menu .dropdown-item .reward-menu-icon {
  margin-right: 0.313rem;
}
header .reward-menu-wrap .reward-menu .dropdown-item .reward-menu-icon svg {
  height: 3rem;
  width: 3rem;
  margin: 0;
}
header .reward-menu-wrap .reward-menu .reward-list {
  background-color: var(--gray-85);
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
}
header .reward-menu-wrap .reward-menu .reward-list .bonus-type {
  display: flex;
  align-items: center;
  gap: 1rem;
}
header .reward-menu-wrap .reward-menu .reward-list .bonus-type p {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--white);
}
header .reward-menu-wrap .reward-menu .reward-list .bonus-type img {
  width: 44px;
}
header .reward-menu-wrap .reward-menu .reward-list .bonus-btn button {
  min-height: 2.5rem;
  padding: 0.25rem 1rem !important;
  justify-content: center;
  display: flex;
  align-items: center;
}
@media screen and (max-width: 767.98px) {
  header .reward-menu-wrap .reward-menu .reward-list .bonus-btn button {
    min-width: 110px !important;
    font-size: 0.875rem;
  }
}
header .reward-menu-wrap .reward-menu .reward-list .bonus-btn button span {
  display: flex;
  align-items: center;
}
header .reward-menu-wrap .reward-menu .reward-list .bonus-btn button svg {
  width: 1rem;
  height: 1rem;
  margin-right: 0.313rem;
}
header .reward-menu-wrap .reward-menu .dropdown-btn-wrap .btn-primary {
  background: var(--gray-80);
}
header .reward-menu-wrap .reward-menu .dropdown-btn-wrap .btn-primary:hover {
  background: var(--secondaryRadialBtn);
  border-color: var(--secondaryBtnBorder);
}
header .reward-menu-wrap .view-dashboard {
  color: var(--gray-20);
  font-size: 1rem;
  font-weight: 500;
}
header .reward-menu-wrap .view-dashboard:hover {
  color: var(--white);
}
header .provider-list .casino-search {
  background: transparent;
}
header .provider-list .casino-search .search-icon {
  top: 0.9rem;
}
header .provider-list .casino-search input {
  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.19) !important;
}
header .header-toggle-icon,
header .header-user-menu {
  margin-left: 6rem;
}
@media screen and (max-width: 767.98px) {
  header .header-toggle-icon,
  header .header-user-menu {
    margin-left: 0.5rem;
  }
}
header .reward-btn .btn-primary {
  padding: 0.625rem 0.5rem;
  background: var(--gray-85);
  border: none;
}
header .reward-btn .btn-primary:hover, header .reward-btn .btn-primary:focus {
  background-color: #000000 !important;
}
header .reward-btn .btn-primary .dropdown-icon {
  width: 24px;
  height: 24px;
  color: var(--gray-20);
  border-radius: 0.5rem;
  background: var(--gray-80);
  line-height: 1.6;
}
header .reward-btn .btn-primary:hover .dropdown-icon, header .reward-btn .btn-primary:focus .dropdown-icon {
  background-color: var(--gray-80);
}
@media screen and (max-width: 767.98px) {
  header .reward-btn .btn-primary {
    padding: 0.25rem 0.5rem;
  }
}
@media screen and (max-width: 575.98px) {
  header .reward-btn .btn-primary {
    min-height: 2.5rem;
    width: 2.5rem;
    padding: 6px;
  }
  header .reward-btn .btn-primary svg {
    width: 22px;
  }
}
header .reward-btn.show .dropdown-icon {
  background-color: var(--gray-80) !important;
}
header .account-btn:hover .dropdown-icon {
  background-color: var(--gray-80) !important;
}
header .top-header-right {
  display: flex;
}
header .top-header-right .btn-primary {
  position: relative;
}
header .top-header-right .btn-primary svg {
  position: absolute;
  transform: translate(-50%, -50%);
}
header .top-header-right .btn-primary svg:nth-child(2) {
  opacity: 0;
}
header .top-header-right .btn-primary.active {
  background: var(--gray-60) !important;
}
header .top-header-right .btn-primary.active svg {
  fill: var(--blue-300);
}
header .top-header-right .btn-primary:hover {
  background: var(--gray-60) !important;
}
header .top-header-right .btn-primary:hover svg {
  fill: var(--blue-300);
}

.search-dilog {
  max-width: 1408px;
}
.search-dilog .search-modal {
  background-color: var(--darkGray) !important;
}
.search-dilog .search-modal .search-modal-wrap {
  padding: 2rem;
}
@media screen and (max-width: 1199.98px) {
  .search-dilog .search-modal .search-modal-wrap {
    padding: 2rem 2rem 5rem 2rem;
  }
}
.search-dilog .search-modal .search-modal-wrap .nav-link {
  background: var(--gray-85);
  min-width: 100%;
  width: 100%;
  margin: 0;
  justify-content: flex-start;
  border: none;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 0;
  padding: 0.6rem 1rem;
  min-height: 2.5rem;
}
.search-dilog .search-modal .search-modal-wrap .nav-link.active, .search-dilog .search-modal .search-modal-wrap .nav-link:hover {
  background: var(--gray-90);
}
.search-dilog .search-modal .search-modal-wrap .nav-link.active img, .search-dilog .search-modal .search-modal-wrap .nav-link:hover img {
  filter: brightness(10);
}
.search-dilog .search-modal .search-modal-wrap .nav-link img {
  margin-right: 0.8rem;
  width: 1rem;
}
@media screen and (max-width: 767.98px) {
  .search-dilog .search-modal .search-modal-wrap .search-modal-right-section {
    padding: 0;
  }
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-modal-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-modal-heading h4 {
  color: var(--white);
  margin: 0;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 1.375rem;
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .casino-search {
  flex: 1 1;
  margin-right: 0;
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .casino-search input {
  height: 48px;
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-filter-right .btn-primary {
  font-size: 0.875rem;
  min-height: 48px;
  background: var(--gray-80);
  border-color: var(--gray-80);
  color: var(--gray-20);
  cursor: pointer;
  padding: 0.25rem 1.125rem;
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-filter-right .btn-primary span {
  color: var(--white);
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-filter-right .btn-primary:after {
  margin-left: 1rem !important;
  transition: transform 0.3s;
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-filter-right .btn-primary.show, .search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-filter-right .btn-primary:visited {
  background: var(--gray-80) !important;
  border-color: var(--gray-80) !important;
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-filter-right .btn-primary.show:after, .search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-filter-right .btn-primary:visited:after {
  transform: rotate(180deg);
}
@media screen and (max-width: 767.98px) {
  .search-dilog .search-modal .search-modal-wrap .search-modal-right-section .search-filter-right .btn {
    width: 100%;
  }
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .global-casino-section {
  padding: 0 0.625rem;
}
.search-dilog .search-modal .search-modal-wrap .search-modal-right-section .global-casino-section .theme-card-wrap {
  margin: 0.5rem 0;
  width: 100%;
  min-width: 100%;
}
@media screen and (max-width: 767.98px) {
  .search-dilog .search-modal .search-modal-wrap .search-modal-right-section .load-more-wrap .btn {
    justify-content: center;
  }
}
@media screen and (min-width: 1200px) {
  .search-dilog .search-modal .search-modal-wrap .search-modal-right-section .global-casino-section .col-lg-2 {
    width: 14.285%;
  }
}
.search-dilog .search-modal .search-modal-wrap .profile-tabs {
  position: sticky;
  top: 1rem;
  background: var(--gray-85);
  border-radius: 0.625rem;
  padding: 0;
  overflow: hidden;
  max-width: 190px;
  margin-right: 2rem;
}

@media screen and (max-width: 1199.98px) {
  .auth-modal-wrap {
    min-width: 80%;
  }
}

@media screen and (max-width: 767.98px) {
  .currency-wrapper .btn-wallet {
    padding: 4px 11px;
  }
}
header .menuBtn {
  display: none;
  z-index: 1;
}

header .menuBtn.toggleBtn {
  transform: scaleX(-1);
}

.chat-sidebar {
  position: fixed;
  right: 0;
  top: 4.75rem;
  background: var(--gray-90);
  height: calc(100dvh - 50px);
  width: 248px;
  border-left: 1px solid var(--gray-80);
  transition: all 0.4s ease-in-out;
}
@media screen and (max-width: 575.98px) {
  .chat-sidebar {
    top: 4rem;
  }
}
.chat-sidebar .chat-content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.chat-sidebar.chat-collapse {
  width: 352px;
}
@media screen and (max-width: 767.98px) {
  .chat-sidebar.chat-collapse {
    width: 100%;
  }
}
.chat-sidebar.chat-collapse .chat-collapse-icon {
  transform: rotate(180deg);
}
.chat-sidebar.chat-collapse .chat-collapse-icon svg {
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
}
.chat-sidebar.chat-collapse .btn-secondary {
  min-width: 110px;
}
@media screen and (max-width: 767.98px) {
  .chat-sidebar {
    width: 100%;
  }
}
.chat-sidebar .chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--gray-80);
  padding: 1rem;
  margin-bottom: 1rem;
}
.chat-sidebar .chat-header .chat-btn {
  background: var(--gray-60) !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.chat-sidebar .chat-header .language-btn a {
  color: var(--white);
  font-weight: 600;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
}
.chat-sidebar .chat-header .language-btn a i {
  font-size: 1rem;
}
.chat-sidebar .chat-header .language-btn button:hover, .chat-sidebar .chat-header .language-btn button:active {
  background: var(--gray-60) !important;
}
.chat-sidebar .chat-header .btn-primary {
  background: transparent;
  border: none;
  width: 100%;
  font-size: 0.875rem;
  padding: 0 0.5rem;
  box-shadow: none;
  color: var(--gray-20);
  min-height: 2.25rem;
  font-weight: 500;
}
.chat-sidebar .chat-header .btn-primary svg {
  margin-right: 0.3125rem;
  height: 1.125rem;
}
.chat-sidebar .chat-header .btn-primary svg,
.chat-sidebar .chat-header .btn-primary path {
  transition: fill 0.3s ease 0s;
}
.chat-sidebar .chat-header .btn-primary.active, .chat-sidebar .chat-header .btn-primary:hover {
  border-color: transparent;
  background: transparent;
  color: var(--white);
}
.chat-sidebar .chat-header .btn-primary.active svg,
.chat-sidebar .chat-header .btn-primary.active path, .chat-sidebar .chat-header .btn-primary:hover svg,
.chat-sidebar .chat-header .btn-primary:hover path {
  fill: var(--blue-300);
}
.chat-sidebar .chat-header .btn-secondary {
  height: 2.375rem;
  width: 100%;
  font-size: 0.74rem;
  margin: 0 0.313rem;
  padding: 0.25rem 0.625rem;
  box-shadow: none;
}
@media screen and (max-width: 767.98px) {
  .chat-sidebar .chat-header .btn-secondary {
    min-width: 140px;
  }
}
.chat-sidebar .chat-header .btn-secondary.active, .chat-sidebar .chat-header .btn-secondary:hover {
  border-color: var(--blue-300);
  background: transparent;
  color: var(--white);
}
.chat-sidebar .chat-header > a {
  width: 100%;
  color: var(--white);
  text-align: center;
  font-size: 0.74rem;
  background: var(--gray-85);
  min-height: 2.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.625rem;
  margin: 0 0.313rem;
  border: 1px solid var(--gray-85);
}
.chat-sidebar .chat-header > a.active, .chat-sidebar .chat-header > a:hover {
  background: var(--darkGray);
  border-color: var(--secondaryBtnBorder);
  color: var(--secondaryBtnBorder);
}
.chat-sidebar .chat-header .chat-close {
  background: transparent;
  padding: 0;
  align-items: center;
  display: flex;
  justify-content: center;
  border: none;
  position: relative;
  color: var(--gray-20);
}
.chat-sidebar .chat-header .chat-close.active, .chat-sidebar .chat-header .chat-close:hover {
  background: transparent;
  border-color: transparent;
  color: var(--blue-300);
}
.chat-sidebar .chat-header .chat-collapse-icon {
  background: transparent;
  padding: 0;
  margin: 0 0.2rem;
  width: 5rem;
  align-items: center;
  display: flex;
  justify-content: center;
  border: none;
  position: relative;
}
.chat-sidebar .chat-header .chat-collapse-icon.active, .chat-sidebar .chat-header .chat-collapse-icon:hover {
  background: transparent;
  border-color: transparent;
}
.chat-sidebar .chat-header .chat-collapse-icon.active svg path:nth-child(1), .chat-sidebar .chat-header .chat-collapse-icon:hover svg path:nth-child(1) {
  stroke: var(--blue-300);
}
.chat-sidebar .chat-header .chat-collapse-icon.active svg path:nth-child(2), .chat-sidebar .chat-header .chat-collapse-icon:hover svg path:nth-child(2) {
  fill: var(--blue-300);
}
@media screen and (max-width: 991.98px) {
  .chat-sidebar .chat-header .chat-collapse-icon {
    display: none;
  }
}
.chat-sidebar .chat-header .dropdown-toggle::after {
  display: inline-block;
}
.chat-sidebar .chat-header .dropdown-menu {
  min-width: 100%;
  padding: 0.25rem;
  border-radius: 0.5rem;
}
.chat-sidebar .chat-header .dropdown-menu a {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  gap: 0.75rem;
  width: 128px;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-weight: 400;
}
.chat-sidebar .chat-header .dropdown-menu a img {
  width: 18px;
  object-fit: cover;
}
.chat-sidebar .chat-announcement-card {
  background: var(--blue-300);
  border-radius: 0.313rem;
  margin-bottom: 0.25rem;
  padding: 0.625rem;
  position: relative;
}
.chat-sidebar .chat-announcement-card:last-child {
  margin-bottom: 0;
}
.chat-sidebar .chat-announcement-card p {
  color: var(--white);
  font-size: 0.75rem;
  margin: 0;
  padding-right: 0.4rem;
  line-height: 1.3;
  word-break: break-all;
}
.chat-sidebar .chat-announcement-card a {
  color: var(--white);
  font-size: 0.625rem;
}
.chat-sidebar .chat-content-scroll {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0px;
  overflow-wrap: break-word;
  overflow: hidden auto;
  margin-bottom: 30px;
  border-bottom: 2px solid var(--gray-80);
}
@media screen and (max-width: 1199.98px) {
  .chat-sidebar .chat-content-scroll {
    height: calc(100vh - 315px);
  }
}
@media screen and (max-width: 767.98px) {
  .chat-sidebar .chat-content-scroll {
    height: calc(100vh - 315px);
  }
}
.chat-sidebar .chat-content-scroll .empty-chat {
  width: 100%;
  padding: 5px;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap {
  padding: 1rem 1rem 0.5rem 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-bubble:nth-child(1) {
  margin-top: auto;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .new_message {
  color: #00a4fa;
  text-align: center;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .new_message::before {
  background-color: #00a4fa;
  content: "";
  display: inline-block;
  height: 1px;
  position: relative;
  vertical-align: middle;
  width: 100%;
  right: 0.5em;
  margin-left: -50%;
}
@media screen and (max-width: 767.98px) {
  .chat-sidebar .chat-content-scroll .chat-content-wrap {
    width: 100%;
    height: calc(100vh - 260px);
  }
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card {
  margin: 0.5rem 0;
  border-radius: 0.5rem;
  background: var(--gray-80-50);
  padding: 0.75rem;
  color: var(--white);
  word-break: break-word;
  position: relative;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card:hover {
  background: var(--gray-80);
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card h4 {
  font-weight: 600;
  padding-right: 0.313rem;
  cursor: pointer;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card p span {
  font-weight: 400;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card p .tagged-name {
  color: var(--white);
  font-weight: 400;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card p .chat-msg {
  color: var(--gray-10);
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .user-icon {
  width: 1rem;
  margin-right: 0.313rem;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card:first-child {
  margin-top: auto;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-card-head .chat-badge-lising {
  margin: 0 0.1rem;
  display: flex;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-card-head .chat-badge-lising svg {
  margin: 0 0.1rem;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-card-head .chat-avtar img {
  object-fit: cover;
  border-radius: 12px;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-card-head .user-clr-one {
  margin-bottom: 0;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-card-head .user-clr-one img {
  object-fit: cover;
  border-radius: 12px;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-card-head .user-clr-one .mod-badge {
  font-weight: 600;
  font-size: 12px;
  border-radius: 4px;
  margin-right: 4px;
  color: var(--darkGray);
  line-height: 18px;
  min-height: 18px;
  width: 35px;
  padding: 0 4px;
  display: inline-block;
  cursor: pointer;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-card-head .user-clr-one .chat-user-label {
  vertical-align: middle;
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--white);
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-card-head .user-clr-one .gif_img {
  pointer-events: none;
  cursor: default;
  height: 60px;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-card-head .gif-chat-box {
  display: flex;
  align-items: center;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-card-head .gif-chat-box .chat-user-label {
  white-space: nowrap;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-card-head .gif-chat-box .gif_img {
  max-width: 75px;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-time {
  font-size: 0.625rem;
  font-weight: 300;
  color: var(--gray-20);
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .chat-text {
  color: var(--gray-10-80);
  word-break: break-all;
  font-size: 0.875rem;
  line-height: 26px;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card .report-user-wrap {
  padding: 0.2rem;
  min-width: 32px;
  min-height: 30px;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0.313rem;
  top: 0;
  display: none;
  cursor: pointer;
}
.chat-sidebar .chat-content-scroll .chat-content-wrap .chat-card:hover .report-user-wrap {
  display: flex;
}
.chat-sidebar .chat-content-scroll::-webkit-scrollbar {
  width: 0;
}
.chat-sidebar .chat-bottom-section {
  padding: 1rem;
  position: relative;
  top: -1.875rem;
}
@media screen and (max-width: 1199.98px) {
  .chat-sidebar .chat-bottom-section {
    padding: 1rem 1rem 5.25rem 1rem;
  }
}
.chat-sidebar .chat-bottom-section .chat-typing {
  position: relative;
}
.chat-sidebar .chat-bottom-section .chat-typing textarea {
  background-color: var(--darkGray) !important;
  font-size: 0.875rem !important;
  border: 2px solid var(--gray-80) !important;
  padding-right: 4.375rem !important;
  border-radius: 0.5rem;
  margin-bottom: 0.625rem;
  color: var(--gray-40);
  font-family: "Rubik", sans-serif !important;
}
.chat-sidebar .chat-bottom-section .chat-typing textarea:focus {
  outline: none;
  color: var(--white);
}
.chat-sidebar .chat-bottom-section .chat-typing textarea:focus::placeholder {
  color: var(--white) !important;
}
.chat-sidebar .chat-bottom-section .chat-typing div .giphy-carousel {
  width: 285px;
  position: absolute;
  bottom: 79px;
  right: 0;
}
.chat-sidebar .chat-bottom-section .chat-typing div .giphy-carousel .giphy-gif {
  width: 100px !important;
  height: 100px !important;
}
.chat-sidebar .chat-bottom-section .chat-typing div .giphy-carousel .giphy-attribution {
  display: none !important;
}
.chat-sidebar .chat-bottom-section .chat-typing div button {
  border: 1px solid transparent;
  background-color: transparent !important;
}
.chat-sidebar .chat-bottom-section .chat-typing .chat-input-cta {
  position: absolute;
  z-index: 1;
  right: 0.625rem;
  bottom: 0.5rem;
}
.chat-sidebar .chat-bottom-section .chat-typing .chat-input-cta svg {
  cursor: pointer;
  margin: 0 0.2rem;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap {
  margin-top: 0.625rem;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .btn {
  min-height: 1.688rem;
  padding: 0 0.5rem;
  font-size: 0.74rem;
  border-radius: 0.375rem;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap img {
  margin-right: 0.313rem;
  width: 1rem;
  height: 1rem;
  border-radius: 1rem;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap a {
  color: var(--gray-10);
  font-weight: 400;
  font-size: 0.875rem;
  display: flex;
  gap: 8px;
  padding: 0.45rem;
  align-items: center;
  width: 8rem;
  height: 2rem;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap a i {
  font-size: 1rem;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .dropdown-item img {
  margin-right: 0;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .chat-rules {
  background-color: var(--gray-80);
  padding: 7px;
  border-radius: 4px;
  width: auto;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .chat-rules:focus {
  background: var(--gray-60);
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .chat-rules:focus svg path {
  stroke: var(--blue-300);
}
.chat-sidebar .chat-bottom-section .chat-details-wrap ul {
  background-color: var(--gray-80);
  padding: 12px !important;
  min-width: 9rem;
  border-radius: 0.5rem;
  border: none;
  box-shadow: var(--dropdownShadow);
}
.chat-sidebar .chat-bottom-section .chat-details-wrap ul li {
  border-radius: 4px;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap ul li:hover {
  background: var(--gray-60);
}
.chat-sidebar .chat-bottom-section .chat-details-wrap ul li:hover a {
  color: var(--gray-10);
}
.chat-sidebar .chat-bottom-section .chat-details-wrap ul li:hover a:hover {
  background: transparent;
  color: var(--white);
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .progress-wrap {
  border: 2px solid var(--c);
  border-radius: 50%;
  height: 14px;
  width: 14px;
  margin-right: 6px;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .progress-wrap .pie {
  width: var(--w);
  aspect-ratio: 1;
  position: relative;
  display: inline-grid;
  place-content: center;
  font-size: 25px;
  font-weight: bold;
  font-family: sans-serif;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .progress-wrap .pie:before,
.chat-sidebar .chat-bottom-section .chat-details-wrap .progress-wrap .pie:after {
  content: "";
  position: absolute;
  border-radius: 50%;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .progress-wrap .pie:before {
  inset: 2px;
  background: radial-gradient(farthest-side, var(--c) 98%, rgba(0, 0, 0, 0)) top/var(--b) var(--b) no-repeat, conic-gradient(var(--c) calc(var(--p) * 1%), rgba(0, 0, 0, 0) 0);
  mask: radial-gradient(farthest-side, rgba(0, 0, 0, 0) calc(99% - var(--b)), #000 calc(100% - var(--b)));
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .progress-wrap .pie:after {
  inset: calc(50% - var(--b) / 2);
  background: var(--c);
  transform: rotate(calc(var(--p) * 3.6deg)) translateY(calc(50% - var(--w) / 2));
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .progress-wrap .animate {
  animation: p 1s 0.5s both;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .progress-wrap .no-round:before {
  background-size: 0 0, auto;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .progress-wrap .no-round:after {
  content: none;
}
@keyframes p {
  from {
    --p: 0;
  }
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .text-limit {
  width: 25px;
  font-size: 0.875rem;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .btn-primary {
  font-weight: 400 !important;
  font-size: 0.875rem !important;
  min-height: 2rem;
  min-width: 100px;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .btn-primary:hover, .chat-sidebar .chat-bottom-section .chat-details-wrap .btn-primary:focus, .chat-sidebar .chat-bottom-section .chat-details-wrap .btn-primary:active {
  background: var(--gray-60) !important;
  border-color: var(--gray-60) !important;
  color: var(--white);
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .btn-secondary {
  font-weight: 500 !important;
  font-size: 1rem !important;
  max-width: 56px;
  min-width: 56px;
  min-height: 32px;
}
.chat-sidebar .chat-bottom-section .chat-details-wrap .dropdown-toggle::after {
  margin-left: 0.5rem;
}
.chat-sidebar .chat-bottom-section .gif-input {
  height: 2rem !important;
  width: 80%;
  margin: 0 auto 0.25rem !important;
}

.user-profile-modal .modal-body {
  padding: 0.625rem !important;
}
.user-profile-modal .btn-close {
  background-color: var(--gray-60) !important;
  border: 2px solid var(--gray-90) !important;
  opacity: 1 !important;
}
@media screen and (max-width: 1199.98px) {
  .user-profile-modal .modal-content {
    margin-bottom: 5rem;
  }
}

.chat-modal {
  color: var(--white);
}
.chat-modal .btn-close {
  position: absolute;
  height: 1rem;
  width: 1rem;
  right: 0.313rem;
  top: 0.313rem;
  border-radius: 100%;
  background: var(--gray-80);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 767.98px) {
  .chat-modal .btn-close {
    right: 0.625rem;
    top: 0.625rem;
  }
}
.chat-modal .btn-close:hover {
  opacity: 1;
}
.chat-modal .btn-close svg {
  width: 0.625rem;
  height: 0.625rem;
}
.chat-modal .modal-dialog {
  max-width: 442px;
}
@media screen and (max-width: 767.98px) {
  .chat-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }
}
.chat-modal .chat-modal-header-wrap {
  background: var(--gray-80-50);
  border-radius: 0.625rem;
  margin-bottom: 0.5rem;
}
.chat-modal .chat-modal-header-wrap h4 {
  text-transform: capitalize;
  margin: 0;
  padding-right: 1rem;
  font-size: 1.125rem;
  font-weight: 600;
}
.chat-modal .chat-modal-header-wrap .tip-btn {
  height: 1.5rem;
  min-height: 1.5rem;
  background: var(--gray-80);
  border: 1px solid var(--blue-300);
  border-radius: 0.5rem;
  color: var(--white);
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0.5rem 0 0.313rem;
  margin-right: 0.75rem;
}
.chat-modal .chat-modal-header-wrap .tip-btn img {
  width: 0.938rem;
  height: 0.938rem;
}
.chat-modal .chat-modal-header-wrap .edit-btn {
  min-height: unset;
  height: 1.5rem;
  width: 1.5rem;
  border: 1px solid var(--gray-60);
  border-radius: 0.5rem;
  color: var(--gray-40);
  font-size: 0.875rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0 0 0 auto;
}
.chat-modal .chat-modal-header-wrap .edit-btn i {
  font-size: 13px;
}
.chat-modal .chat-modal-header-wrap .chat-modal-header-right {
  flex: 1 1;
}
.chat-modal .chat-modal-header-wrap .chat-modal-header-right .progress {
  height: 6px;
}
.chat-modal .chat-modal-content {
  background: var(--gray-80-50);
  border-radius: 0.5rem;
  margin-top: 0.5rem;
  padding: 1rem;
}
.chat-modal .chat-modal-content .chat-bets-wrap {
  column-gap: 1rem;
  row-gap: 0.5rem;
}
@media screen and (max-width: 575.98px) {
  .chat-modal .chat-modal-content .chat-bets-wrap {
    column-gap: 0.5rem;
    row-gap: 0.25rem;
  }
}
.chat-modal .chat-modal-content .chat-bets {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(50% - 1rem + 0.5rem);
  max-width: calc(50% - 1rem + 0.5rem);
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1;
}
.chat-modal .chat-modal-content .chat-bets h4 {
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1;
  color: var(--gray-40);
}
@media screen and (max-width: 575.98px) {
  .chat-modal .chat-modal-content .chat-bets h4 {
    line-height: 18px;
    font-size: 0.75rem;
  }
}
.chat-modal .chat-modal-content .chat-bets p {
  padding-left: 0.313rem;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1;
  color: var(--white);
}
@media screen and (max-width: 575.98px) {
  .chat-modal .chat-modal-content .chat-bets p {
    line-height: 18px;
    font-size: 0.75rem;
  }
}
.chat-modal .progrees-content p {
  font-size: 0.875rem;
  color: var(--gray-40);
  font-weight: 500;
}
.chat-modal .progrees-content p span {
  color: var(--live-green);
  padding: 0 0.2rem;
  font-weight: 600;
}
.chat-modal .favourites-game-wrap {
  margin-right: 1rem;
}
.chat-modal .favourites-game-wrap .favourites-game-img {
  height: 78px;
  width: 78px;
  border-radius: 0.313rem;
  overflow: hidden;
  margin-right: 1rem;
}
.chat-modal .favourites-game-wrap .favourites-game-img img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.chat-modal .favourites-game-wrap .favourites-game-right p {
  font-size: 0.75rem;
  color: var(--gray-20);
  font-weight: 600;
}
.chat-modal .favourites-game-wrap .favourites-game-right h4 {
  color: var(--white);
  font-size: 1rem;
  max-width: 140px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 700;
}
.chat-modal .chat-modal-profile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.chat-modal .chat-modal-profile-header .chat-modal-header-details {
  display: flex;
  width: 100%;
  padding-right: 1rem;
}
@media screen and (max-width: 575px) {
  .chat-modal .chat-modal-profile-header {
    flex-direction: column;
    gap: 20px;
    padding-bottom: 1rem;
  }
}
.chat-modal .chat-modal-profile-img {
  padding: 1rem;
  border-right: 1px solid var(--gray-80);
}
@media screen and (max-width: 575.98px) {
  .chat-modal .chat-modal-profile-img {
    border-right: none;
    padding: 1rem 0 0 0;
  }
}
.chat-modal .chat-modal-profile-img img {
  flex: 0 0 5rem;
  max-width: 5rem;
  height: 5rem;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
}
.chat-modal .chat-modal-header-left {
  width: 4.375rem;
}
.chat-modal .chat-modal-header-left img {
  width: 100%;
  max-width: 62px;
  height: auto;
}
.chat-modal .modal-body {
  padding: 0.625rem;
  background: var(--gray-90);
  border-radius: 1rem;
  border: 1px;
}

.account-btn-mid-content {
  font-weight: 600;
}
@media screen and (max-width: 767.98px) {
  .account-btn-mid-content p {
    font-size: 0.74rem;
  }
  .btn.balance-btn {
    font-size: 0.74rem;
  }
}
.btn.balance-btn:hover {
  background: var(--darkGray);
  cursor: default;
}
@media screen and (max-width: 767.98px) {
  .btn {
    padding: 0.25rem 0.625rem;
  }
}

.chat-modal-wrap .modal-dialog {
  position: relative;
  border-radius: 0.625rem;
  min-width: 620px;
}
.chat-modal-wrap .btn-close {
  filter: invert(10);
  opacity: 1;
  width: 0.625rem;
  background-size: 0.625rem;
  right: 0.313rem;
  top: 0.313rem;
  position: absolute;
  z-index: 1;
  box-shadow: none;
}

.upload-modal .modal-dialog {
  max-width: 468px !important;
}
.upload-modal .modal-dialog .btn-close {
  border-radius: 100%;
  background: var(--gray-80);
  opacity: 1;
  top: 1.5rem;
  right: 1.5rem;
}
.upload-modal .modal-dialog .profile-pic-wrapper .image-upload-box {
  position: relative;
}
.upload-modal .modal-dialog .profile-pic-wrapper .image-upload-box svg {
  width: 45px;
}
.upload-modal .modal-dialog .profile-pic-wrapper .image-upload-box .drop-title {
  margin-bottom: 0;
  font-weight: 500;
  font-size: 0.875rem;
}
.upload-modal .modal-dialog .profile-pic-wrapper .image-upload-box .drop-title span {
  color: var(--blue-300);
  text-decoration: underline;
}
.upload-modal .modal-dialog .profile-pic-wrapper .image-upload-box .drop-title span:hover {
  text-decoration: none;
  cursor: pointer;
}
.upload-modal .modal-dialog .profile-pic-wrapper .image-upload-box .drop-title ::-webkit-file-upload-button {
  cursor: pointer;
}
.upload-modal .modal-dialog .profile-pic-wrapper .image-upload-box .drop-limit {
  margin-bottom: 0;
  font-weight: 400;
  font-size: 0.875rem;
  color: var(--gray-40);
}
.upload-modal .modal-dialog .profile-pic-wrapper input[type=file] {
  position: absolute;
  top: -2px;
  height: 20px;
  right: 0;
  width: 50px;
  cursor: pointer;
  opacity: 0;
}
.upload-modal .modal-footer .btn-primary {
  border: 1px solid var(--blue-300);
  color: var(--blue-50);
  background-color: transparent;
}
.upload-modal .modal-footer .btn-primary:hover {
  border: 1px solid var(--blue-100);
  background-color: transparent !important;
}

.tip-modal .modal-content {
  padding: 1.5rem;
}
@media screen and (max-width: 767.98px) {
  .tip-modal .modal-content {
    padding: 1rem;
  }
}
.tip-modal-body {
  margin-top: 1.5rem;
  background-color: var(--gray-85);
  border-radius: 8px;
  padding: 1.5rem;
}
@media screen and (max-width: 767.98px) {
  .tip-modal-body {
    padding: 1rem;
  }
}

#profile-pic-modal .modal-footer {
  background: transparent;
}

.cashier-modal .modal-dialog {
  min-width: 805px;
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog {
    height: 100%;
  }
  .cashier-modal .modal-dialog .btn-close {
    top: 25px;
  }
}
.cashier-modal .modal-dialog .modal-content {
  border-radius: 12px;
}
@media screen and (max-width: 1024.98px) {
  .cashier-modal .modal-dialog .modal-content {
    border: 0;
    border-radius: 0;
  }
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .modal-content .modal-body {
    display: flex;
    flex-direction: column;
    background-color: var(--gray-90);
  }
  .cashier-modal .modal-dialog .modal-content .tab-content {
    flex: 1 1;
  }
  .cashier-modal .modal-dialog .modal-content .tab-pane {
    height: 100%;
  }
}
@media screen and (max-width: 1024.98px) {
  .cashier-modal .modal-dialog {
    min-width: 100%;
    margin: 0;
    padding: 0;
    border-radius: 0;
  }
}
.cashier-modal .modal-dialog .modal-body {
  padding: 1.5rem;
}
@media screen and (max-width: 1024.98px) {
  .cashier-modal .modal-dialog .modal-body {
    padding: 1rem;
  }
}
.cashier-modal .modal-dialog .modal-body .nav-link {
  color: var(--gray-40);
  opacity: 0.8;
}
.cashier-modal .modal-dialog .modal-body .nav-tabs .nav-item .nav-link:hover,
.cashier-modal .modal-dialog .modal-body .nav-tabs .nav-item .nav-link.active,
.cashier-modal .modal-dialog .modal-body .nav-pills .nav-item .nav-link:hover,
.cashier-modal .modal-dialog .modal-body .nav-pills .nav-item .nav-link.active {
  color: var(--white);
  border-color: var(--gray-80);
}
.cashier-modal .modal-dialog .cashier-heading {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .cashier-heading {
    flex-direction: column;
    align-items: flex-start;
    row-gap: 1rem;
    margin-bottom: 1rem;
  }
}
.cashier-modal .modal-dialog .cashier-heading h3 {
  display: flex;
  align-items: center;
  font-size: 1.25rem;
  color: var(--white);
  font-weight: 700;
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .cashier-heading h3 {
    font-size: 1rem;
  }
}
.cashier-modal .modal-dialog .cashier-heading a {
  color: var(--blue-300);
  font-size: 1rem;
  padding-left: 1rem;
  font-weight: 500;
  line-height: 1;
  text-decoration: underline;
}
.cashier-modal .modal-dialog .cashier-heading .currency-icon {
  height: 30px;
  width: 30px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.625rem;
}
.cashier-modal .modal-dialog .cashier-heading .currency-icon img {
  height: 100%;
  object-fit: cover;
}
.cashier-modal .modal-dialog .cashier-heading .left-arrow {
  padding: 0;
}
.cashier-modal .modal-dialog .cashier-heading .left-arrow svg {
  filter: brightness(10);
  width: 1rem;
  height: 1rem;
  margin-right: 1rem;
}
.cashier-modal .modal-dialog .modal-inner-card {
  padding: 1.5rem;
  border-radius: 0.625rem;
  color: var(--gray-20);
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .modal-inner-card {
    padding: 1rem;
  }
}
.cashier-modal .modal-dialog .modal-inner-card p {
  margin-bottom: 0;
  padding-right: 2rem;
  line-height: 1.6;
  color: var(--gray-20);
  font-size: 1rem;
  font-weight: 400;
  font-style: normal;
}
.cashier-modal .modal-dialog .modal-inner-card .qr-code canvas {
  border: 5px solid var(--white);
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .modal-inner-card .qr-code {
    margin-bottom: 1rem;
    margin-top: 1rem;
  }
}
.cashier-modal .modal-dialog .modal-inner-card .qr-code img {
  width: 100%;
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .modal-inner-card .change-username label {
    font-size: 0.75rem;
  }
}
.cashier-modal .modal-dialog .modal-inner-card .change-username label span {
  color: var(--red);
}
.cashier-modal .modal-dialog .modal-inner-card .change-username .form-group {
  position: relative;
}
.cashier-modal .modal-dialog .modal-inner-card .change-username .form-group .btn-secondary {
  position: absolute;
  right: 0.35rem;
  top: 0.375rem;
  min-height: 2.25rem;
  font-size: 0.813rem;
  display: flex;
  align-items: center;
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .modal-inner-card .change-username .form-group .form-control {
    padding-right: 5.7rem;
  }
}
.cashier-modal .modal-dialog .modal-inner-card .change-username .form-group .form-control:focus {
  border-color: var(--secondaryBtnBorder);
}
.cashier-modal .modal-dialog .modal-inner-card .change-username p {
  color: var(--white);
  text-transform: uppercase;
  font-size: 0.875rem;
  line-height: 1.75rem;
  font-weight: 700;
}
.cashier-modal .modal-dialog .modal-inner-card .change-username .form-text-wrap {
  margin: 0.313rem 0;
}
.cashier-modal .modal-dialog .modal-inner-card .change-username .form-text-wrap p {
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.063;
  color: var(--gray-40);
  text-transform: capitalize;
}
.cashier-modal .modal-dialog .modal-inner-card .change-username .btn-primary {
  background: var(--gray-80);
}
.cashier-modal .modal-dialog .modal-inner-card .change-username .btn-primary:hover {
  background: var(var(--secondaryBtn));
}
.cashier-modal .modal-dialog .modal-inner-card .currency-converter .form-group {
  position: relative;
}
.cashier-modal .modal-dialog .modal-inner-card .currency-converter .form-group img, .cashier-modal .modal-dialog .modal-inner-card .currency-converter .form-group svg {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  height: 20px;
  width: 20px;
}
.cashier-modal .modal-dialog .modal-inner-card .currency-converter .form-group input {
  padding-left: 2.5rem;
}
.cashier-modal .modal-dialog .modal-inner-card .currency-converter span {
  padding: 0 1rem;
  color: var(--white);
}
.cashier-modal .modal-dialog .modal-inner-card .currency-converter button > span {
  padding: 0;
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .modal-inner-card .payment-left-card {
    flex-direction: column;
  }
}
.cashier-modal .modal-dialog .modal-inner-card .payment-left-card h4 {
  line-height: 1.6;
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 0;
  font-style: normal;
  color: var(--gray-20);
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .modal-inner-card .payment-left-card h4 {
    margin-bottom: 1.5rem;
  }
}
.cashier-modal .modal-dialog .modal-inner-card .payment-card-center {
  display: flex;
  align-items: center;
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .modal-inner-card .payment-card-center {
    justify-content: center;
  }
}
.cashier-modal .modal-dialog .modal-inner-card .payment-card-center img, .cashier-modal .modal-dialog .modal-inner-card .payment-card-center svg {
  margin: 0 0.25rem;
  max-width: 2.875rem;
  max-height: 1.5rem;
}
.cashier-modal .modal-dialog .modal-inner-card .payment-card-right {
  text-align: center;
}
.cashier-modal .modal-dialog .modal-inner-card .payment-card-right button.btn-primary {
  background-color: linear-gradient(#EFD43C, #CB7D00);
  color: var(--gray-20);
}
@media screen and (max-width: 600px) {
  .cashier-modal .modal-dialog .modal-inner-card .payment-card-right .btn {
    width: 100%;
  }
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .modal-inner-card .payment-card-right {
    margin-top: 1.5rem;
  }
}
.cashier-modal .modal-dialog .bitcoin-instruction-list {
  margin-top: 1.2rem;
  margin-bottom: 0;
}
.cashier-modal .modal-dialog .bitcoin-instruction-list li {
  font-size: 0.865rem;
  font-weight: 500;
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .modal-btn-wrap {
    margin-top: 1rem;
  }
}
.cashier-modal .modal-dialog .modal-btn-wrap .btn {
  margin-left: 1rem;
  line-height: 1rem;
  height: 48px;
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .modal-btn-wrap .btn {
    width: 100%;
    margin-left: 0;
    margin-bottom: 1rem;
  }
}
.cashier-modal .modal-dialog .coupon-section {
  text-align: center;
  padding-bottom: 2rem;
  padding-top: 0.5rem;
  background-color: var(--gray-85);
  border-radius: 8px;
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .coupon-section {
    height: 100%;
    padding-top: 1.75rem;
  }
}
.cashier-modal .modal-dialog .coupon-section img {
  width: 8rem;
  height: 8rem;
  margin: 0 auto;
}
.cashier-modal .modal-dialog .coupon-section h4 {
  color: var(--white);
  font-weight: 700;
  font-size: 1.25rem;
  margin-bottom: 0 !important;
}
.cashier-modal .modal-dialog .coupon-section .form-group {
  max-width: 220px;
  margin: 1.25rem auto 1.5rem;
}
.cashier-modal .modal-dialog .coupon-section p {
  color: var(--white);
  font-weight: 500;
}
.cashier-modal .modal-dialog .coupon-section p a {
  color: var(--blue-300);
  padding-left: 0.2rem;
  display: inline-block;
}
.cashier-modal .modal-dialog .custom-tabs-nav {
  width: calc(100% - 1.75rem);
  margin-bottom: 0.5rem;
}
@media screen and (max-width: 767.98px) {
  .cashier-modal .modal-dialog .custom-tabs-nav {
    margin-bottom: 0;
  }
  .cashier-modal .modal-dialog .nav-pills {
    flex-wrap: nowrap;
    overflow-x: auto;
    width: 100%;
  }
  .cashier-modal .modal-dialog .btn-info {
    font-size: 0.75rem;
  }
}
.cashier-modal .modal-dialog .modal-content {
  height: 100%;
}
.cashier-modal .error-msg {
  margin: 0;
  position: absolute;
}

.cashier-btn .nav {
  gap: 0.75rem;
}
.cashier-btn .nav .nav-item .nav-link {
  background-color: var(--gray-85);
  border: 2px solid var(--gray-85);
  border-radius: 0.625rem;
  color: var(--gray-20);
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.75rem;
  padding: 0.375rem 1.625rem;
}
.cashier-btn .nav .nav-item .nav-link:hover {
  background-color: var(--gray-60);
  border: 2px solid var(--gray-60);
  color: var(--blue-300);
}
.cashier-btn .nav .nav-item .nav-link.active, .cashier-btn .nav .nav-item .nav-link.active:hover {
  background-color: var(--gray-85);
  border: 2px solid var(--blue-300);
  color: var(--blue-300) !important;
}

.remove-blur {
  backdrop-filter: blur(0) brightness(1);
}

.mob-reward-btn {
  border: none !important;
  background: var(--gray-80-50) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Header/header.scss"],"names":[],"mappings":"AAAA;EACE,MAAA;EACA,QAAA;EACA,eAAA;EACA,SAAA;AACF;;AAEA;;EAEE,4BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAGE;;;EAGE,oBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,oBAAA;AADF;;AAIA;EACE,kBAAA;EAEA,WAAA;EAGA,MAAA;EACA,WAAA;EACA,gBAAA;EACA,OAAA;EACA,QAAA;AAJF;AAOE;EACE,iBAAA;EACA,cAAA;AALJ;AAQE;EAlBF;IAmBI,gBAAA;EALF;AACF;AASI;EACE,YAAA;AAPN;AASI;EACE,YAAA;AAPN;AASM;EAHF;IAII,WAAA;IACA,YAAA;EANN;AACF;AAQM;EARF;IASI,WAAA;IACA,YAAA;EALN;AACF;AAaI;EACE,uBAAA;AAXN;AAeE;EACE,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,SAAA;EACA,QAAA;AAbJ;AAeI;EACE,6CAAA;AAbN;AAgBI;EAXF;IAYI,gBAAA;IACA,eAAA;EAbJ;AACF;AAeI;EAhBF;IAiBI,iBAAA;EAZJ;AACF;AAcI;EACE,0BAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAZN;AAcM;EACE,qCAAA;EACA,gCAAA;AAZR;AAeM;EACE,2BAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AAbR;AAeQ;EACE,aAAA;AAbV;AAgBQ;EACE,qCAAA;EACA,qBAAA;AAdV;AAiBQ;EAnBF;IAoBI,0BAAA;EAdR;EAgBQ;IACE,0BAAA;EAdV;AACF;AAiBQ;EA3BF;IA4BI,uBAAA;IACA,kBAAA;EAdR;AACF;AAkBI;EACE,qBAAA;EACA,mCAAA;EACA,YAAA;AAhBN;AAkBM;EACE,mBAAA;EACA,YAAA;AAhBR;AAsBI;EACE,eAAA;EACA,cAAA;EACA,uBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yCAAA;AApBN;AAsBM;EACE,6BAAA;AApBR;AAuBM;EACE,oBAAA;AArBR;AAwBM;EACE,0BAAA;AAtBR;AAwBQ;EACE,qBAAA;AAtBV;AA8BM;EADF;IAEI,cAAA;EA3BN;AACF;AAgCI;EACE,gBAAA;EAEA,6CAAA;EACA,cAAA;AA/BN;AAiCM;EAEE,wDAAA;EACA,qBAAA;AAhCR;AAmCM;EAZF;IAaI,mBAAA;EAhCN;AACF;AAkCM;EAhBF;IAiBI,gBAAA;IACA,eAAA;IACA,kBAAA;EA/BN;AACF;AAiCM;EAtBF;IAuBI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,eAAA;IACA,iBAAA;EA9BN;AACF;AAiCI;EACE,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,yBAAA;AA/BN;AAiCM;EANF;IAOI,mBAAA;EA9BN;AACF;AAgCM;EAVF;IAWI,gBAAA;IACA,eAAA;IACA,kBAAA;EA7BN;AACF;AA+BM;EAhBF;IAiBI,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,eAAA;IACA,iBAAA;EA5BN;AACF;AAgCE;EACE,WAAA;EAEA,mBAAA;EACA,uBAAA;EACA,UAAA;AA/BJ;AAiCI;EACE,cAAA;EACA,aAAA;AA/BN;AAkCI;EACE,0BAAA;EACA,4BAAA;EACA,kBAAA;AAhCN;AAoCM;EACE,kBAAA;AAlCR;AAwCI;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,gBAAA;AAtCN;AAwCM;EATF;IAUI,gBAAA;EArCN;AACF;AAuCM;EACE,sBAAA;AArCR;AAuCQ;EACE,gBAAA;AArCV;AAyCM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AAvCR;AAyCQ;EACE,uBAAA;AAvCV;AAyCU;EACE,YAAA;AAvCZ;AA4CU;EACE,mBAAA;EACA,yBAAA;EACA,sBAAA;AA1CZ;AA6CU;EACE,kBAAA;EACA,gBAAA;EACA,wBAAA;AA3CZ;AA+CQ;EACE,YAAA;EACA,oBAAA;EACA,kBAAA;AA7CV;AA+CU;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AA7CZ;AAgDU;EACE,6BAAA;AA9CZ;AAgDY;EACE,uBAAA;EACA,6BAAA;AA9Cd;AAmDQ;EACE,sBAAA;AAjDV;AAmDU;EACE,YAAA;EACA,WAAA;EACA,SAAA;AAjDZ;AAsDM;EACE,gCAAA;EACA,qBAAA;EACA,qBAAA;AApDR;AAsDQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AApDV;AAsDU;EACE,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AApDZ;AAuDU;EACE,WAAA;AArDZ;AA0DU;EACE,kBAAA;EACA,gCAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AAxDZ;AA0DY;EAPF;IAQI,2BAAA;IACA,mBAAA;EAvDZ;AACF;AAyDY;EACE,aAAA;EACA,mBAAA;AAvDd;AA0DY;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AAxDd;AA+DQ;EACE,0BAAA;AA7DV;AA+DU;EACE,qCAAA;EACA,uCAAA;AA7DZ;AAmEI;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;AAjEN;AAmEM;EACE,mBAAA;AAjER;AAuEI;EACE,uBAAA;AArEN;AAuEM;EACE,WAAA;AArER;AAwEM;EACE,0DAAA;AAtER;AA2EE;;EAEE,iBAAA;AAzEJ;AA2EI;EAJF;;IAKI,mBAAA;EAvEJ;AACF;AA4EI;EACE,wBAAA;EACA,0BAAA;EACA,YAAA;AA1EN;AA2EM;EACE,oCAAA;AAzER;AA4EM;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,qBAAA;EACA,0BAAA;EACA,gBAAA;AA1ER;AA+EQ;EACE,gCAAA;AA7EV;AAiFM;EAxBF;IAyBI,uBAAA;EA9EN;AACF;AAgFM;EA5BF;IA6BI,kBAAA;IAEA,aAAA;IACA,YAAA;EA9EN;EAgFM;IACE,WAAA;EA9ER;AACF;AAoFI;EACE,2CAAA;AAlFN;AAsFE;EACE,2CAAA;AApFJ;AAuFE;EACE,aAAA;AArFJ;AAuFI;EACE,kBAAA;AArFN;AAuFM;EACE,kBAAA;EACA,gCAAA;AArFR;AAuFQ;EACE,UAAA;AArFV;AAyFM;EACE,qCAAA;AAvFR;AAyFQ;EACE,qBAAA;AAvFV;AA2FM;EACE,qCAAA;AAzFR;AA2FQ;EACE,qBAAA;AAzFV;;AAgGA;EACE,iBAAA;AA7FF;AA+FE;EACE,4CAAA;AA7FJ;AA+FI;EACE,aAAA;AA7FN;AA+FM;EAHF;IAII,4BAAA;EA5FN;AACF;AA8FM;EACE,0BAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AA5FR;AA8FQ;EAEE,0BAAA;AA7FV;AA+FU;EACE,sBAAA;AA7FZ;AAiGQ;EACE,oBAAA;EACA,WAAA;AA/FV;AAoGQ;EADF;IAEI,UAAA;EAjGR;AACF;AAmGQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAjGV;AAmGU;EACE,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAjGZ;AAqGQ;EACE,SAAA;EACA,eAAA;AAnGV;AAqGU;EACE,YAAA;AAnGZ;AAwGU;EACE,mBAAA;EACA,gBAAA;EACA,0BAAA;EACA,4BAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;AAtGZ;AAwGY;EACE,mBAAA;AAtGd;AAyGY;EACE,4BAAA;EACA,0BAAA;AAvGd;AA0GY;EAEE,qCAAA;EACA,uCAAA;AAzGd;AA2Gc;EACE,yBAAA;AAzGhB;AA8GU;EAEE;IACE,WAAA;EA7GZ;AACF;AAkHQ;EACE,mBAAA;AAhHV;AAmHU;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AAjHZ;AAuHY;EADF;IAEI,uBAAA;EApHZ;AACF;AA0HY;EADF;IAEI,cAAA;EAvHZ;AACF;AA4HM;EACE,gBAAA;EACA,SAAA;EACA,0BAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AA1HR;;AAiIE;EADF;IAEI,cAAA;EA7HF;AACF;;AAgIA;EACE;IACE,iBAAA;EA7HF;AACF;AAgIA;EACE,aAAA;EACA,UAAA;AA9HF;;AAiIA;EACE,qBAAA;AA9HF;;AAiIA;EACE,eAAA;EACA,QAAA;EACA,YAAA;EACA,0BAAA;EACA,2BAAA;EACA,YAAA;EACA,qCAAA;EACA,gCAAA;AA9HF;AAgIE;EAVF;IAWI,SAAA;EA7HF;AACF;AA+HE;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AA7HJ;AAgIE;EACE,YAAA;AA9HJ;AAgII;EAHF;IAII,WAAA;EA7HJ;AACF;AA+HI;EACE,yBAAA;AA7HN;AA+HM;EACE,kBAAA;EACA,gCAAA;EACA,QAAA;EACA,SAAA;AA7HR;AAiII;EACE,gBAAA;AA/HN;AAmIE;EA5CF;IA6CI,WAAA;EAhIF;AACF;AAkIE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;AAhIJ;AAkII;EACE,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhIN;AAoIM;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAlIR;AAoIQ;EACE,eAAA;AAlIV;AAwIQ;EAEE,qCAAA;AAvIV;AAgJI;EACE,uBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AA9IN;AAgJM;EACE,uBAAA;EACA,gBAAA;AA9IR;AAiJM;;EAEE,6BAAA;AA/IR;AAkJM;EAEE,yBAAA;EACA,uBAAA;EACA,mBAAA;AAjJR;AAmJQ;;;EAEE,qBAAA;AAhJV;AAqJI;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AAnJN;AAqJM;EARF;IASI,gBAAA;EAlJN;AACF;AAoJM;EAEE,6BAAA;EACA,uBAAA;EACA,mBAAA;AAnJR;AAuJI;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gCAAA;AArJN;AAuJM;EAEE,2BAAA;EACA,uCAAA;EACA,gCAAA;AAtJR;AA0JI;EACE,uBAAA;EACA,UAAA;EAIA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;AA3JN;AA6JM;EAEE,uBAAA;EACA,yBAAA;EACA,sBAAA;AA5JR;AAgKI;EACE,uBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EAEA,kBAAA;AA/JN;AAiKM;EAEE,uBAAA;EACA,yBAAA;AAhKR;AAmKU;EACE,uBAAA;AAjKZ;AAoKU;EACE,qBAAA;AAlKZ;AAuKM;EA5BF;IA6BI,aAAA;EApKN;AACF;AAwKM;EACE,qBAAA;AAtKR;AA0KI;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;AAxKN;AA0KM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;AAxKR;AA0KQ;EACE,WAAA;EACA,iBAAA;AAxKV;AA8KE;EACE,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AA5KJ;AA8KI;EACE,gBAAA;AA5KN;AA+KI;EACE,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;AA7KN;AAgLI;EACE,mBAAA;EACA,mBAAA;AA9KN;AAkLE;EAKE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uCAAA;AApLJ;AAsLI;EAdF;IAeI,2BAAA;EAnLJ;AACF;AAqLI;EAlBF;IAmBI,2BAAA;EAlLJ;AACF;AAoLI;EACE,WAAA;EACA,YAAA;AAlLN;AAqLI;EACE,8BAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAnLN;AAqLM;EACE,gBAAA;AAnLR;AAsLM;EACE,cAAA;EACA,kBAAA;AApLR;AAuLM;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EAIA,YAAA;EACA,iBAAA;AA1LR;AA6LM;EA/BF;IAgCI,WAAA;IACA,2BAAA;EAtLN;AACF;AAwLM;EACE,gBAAA;EACA,qBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AAtLR;AAwLQ;EACE,0BAAA;AAtLV;AAyLQ;EACE,gBAAA;EACA,uBAAA;EACA,eAAA;AAvLV;AA2LU;EAEE,gBAAA;AA1LZ;AA6LU;EACE,mBAAA;EACA,gBAAA;AA3LZ;AA8LU;EACE,qBAAA;AA5LZ;AAgMQ;EACE,WAAA;EACA,sBAAA;AA9LV;AAiMQ;EACE,gBAAA;AA/LV;AAmMU;EACE,gBAAA;EACA,aAAA;AAjMZ;AAmMY;EACE,gBAAA;AAjMd;AAsMY;EACE,iBAAA;EACA,mBAAA;AApMd;AAwMU;EAKE,gBAAA;AA1MZ;AA4MY;EACE,iBAAA;EACA,mBAAA;AA1Md;AA6MY;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AA3Md;AA8MY;EAEE,sBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,mBAAA;AA9Md;AAiNY;EACE,oBAAA;EACA,eAAA;EACA,YAAA;AA/Md;AAoNU;EACE,aAAA;EACA,mBAAA;AAlNZ;AAoNY;EACE,mBAAA;AAlNd;AAqNY;EACE,eAAA;AAnNd;AAyNQ;EACE,mBAAA;EACA,gBAAA;EACA,qBAAA;AAvNV;AA0NQ;EACE,wBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AAxNV;AA2NQ;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,MAAA;EACA,aAAA;EACA,eAAA;AAzNV;AA6NU;EACE,aAAA;AA3NZ;AAiOI;EACE,QAAA;AA/NN;AAmOE;EACE,aAAA;EACA,kBAAA;EACA,cAAA;AAjOJ;AAmOI;EALF;IAMI,+BAAA;EAhOJ;AACF;AAkOI;EACE,kBAAA;AAhON;AAkOM;EACE,4CAAA;EAEA,8BAAA;EACA,2CAAA;EACA,kCAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,2CAAA;AAjOR;AAsOQ;EACE,aAAA;EACA,mBAAA;AApOV;AAuOU;EACE,8BAAA;AArOZ;AA2OQ;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;AAzOV;AA2OU;EACE,uBAAA;EACA,wBAAA;AAzOZ;AA4OU;EACE,wBAAA;AA1OZ;AA8OQ;EACE,6BAAA;EACA,wCAAA;AA5OV;AAgPM;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;AA9OR;AAgPQ;EACE,eAAA;EACA,gBAAA;AA9OV;AAmPI;EACE,oBAAA;AAjPN;AAmPM;EACE,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AAjPR;AAqPM;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAnPR;AAsPM;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AApPR;AAsPQ;EACE,eAAA;AApPV;AAyPQ;EACE,eAAA;AAvPV;AA2PM;EACE,gCAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAzPR;AA2PQ;EACE,0BAAA;AAzPV;AA4PY;EACE,uBAAA;AA1Pd;AAgQM;EACE,gCAAA;EACA,wBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,iCAAA;AA9PR;AAgQQ;EACE,kBAAA;AA9PV;AAgQU;EACE,0BAAA;AA9PZ;AAgQY;EACE,qBAAA;AA9Pd;AAgQc;EACE,uBAAA;EACA,mBAAA;AA9PhB;AAqQM;EACE,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AAnQR;AAqQQ;EACE,eAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EAEA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AApQV;AAuQQ;;EAEE,WAAA;EACA,kBAAA;EACA,kBAAA;AArQV;AAwQQ;EACE,UAAA;EACA,4KAAA;EAKA,uGAAA;AAzQV;AA8QQ;EACE,+BAAA;EACA,oBAAA;EACA,+EAAA;AA5QV;AA+QQ;EACE,yBAAA;AA7QV;AAgRQ;EACE,0BAAA;AA9QV;AAiRQ;EACE,aAAA;AA/QV;AAkRQ;EACE;IACE,MAAA;EAhRV;AACF;AAoRM;EACE,WAAA;EACA,mBAAA;AAlRR;AAqRM;EACE,2BAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;AAnRR;AAqRQ;EAGE,qCAAA;EACA,uCAAA;EACA,mBAAA;AArRV;AAyRM;EACE,2BAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAvRR;AA2RQ;EACE,mBAAA;AAzRV;AA8RI;EACE,uBAAA;EACA,UAAA;EACA,iCAAA;AA5RN;;AAkSE;EACE,4BAAA;AA/RJ;AAkSE;EACE,2CAAA;EACA,2CAAA;EACA,qBAAA;AAhSJ;AAoSI;EADF;IAEI,mBAAA;EAjSJ;AACF;;AAsSA;EACE,mBAAA;AAnSF;AAqSE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAnSJ;AAqSI;EAbF;IAcI,eAAA;IACA,aAAA;EAlSJ;AACF;AAoSI;EACE,UAAA;AAlSN;AAqSI;EACE,eAAA;EACA,gBAAA;AAnSN;AAuSE;EACE,gBAAA;AArSJ;AAuSI;EAHF;IAII,eAAA;IACA,SAAA;EApSJ;AACF;AAuSE;EACE,6BAAA;EACA,uBAAA;EACA,qBAAA;AArSJ;AAuSI;EACE,0BAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AArSN;AAwSI;EACE,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,iCAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,4BAAA;EACA,qBAAA;AAtSN;AAwSM;EACE,eAAA;EACA,gBAAA;AAtSR;AA0SI;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,gCAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;AAxSN;AA0SM;EACE,eAAA;AAxSR;AA4SI;EACE,SAAA;AA1SN;AA4SM;EACE,WAAA;AA1SR;AA+SE;EACE,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;AA7SJ;AA+SI;EACE,gBAAA;EACA,eAAA;AA7SN;AA+SM;EAJF;IAKI,kBAAA;IACA,gBAAA;EA5SN;AACF;AA+SI;EACE,YAAA;EAAA,cAAA;EAAA,qCAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AA7SN;AA+SM;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AA7SR;AA+SQ;EANF;IAOI,iBAAA;IACA,kBAAA;EA5SR;AACF;AA+SM;EACE,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AA7SR;AA+SQ;EAPF;IAQI,iBAAA;IACA,kBAAA;EA5SR;AACF;AAkTI;EACE,mBAAA;EACA,qBAAA;EACA,gBAAA;AAhTN;AAkTM;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;AAhTR;AAqTE;EACE,kBAAA;AAnTJ;AAqTI;EACE,YAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AAnTN;AAqTM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AAnTR;AAwTM;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;AAtTR;AAyTM;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAvTR;AA4TE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AA1TJ;AA6TI;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AA3TN;AA8TI;EAZF;IAaI,sBAAA;IACA,SAAA;IACA,oBAAA;EA3TJ;AACF;AA8TE;EACE,aAAA;EACA,sCAAA;AA5TJ;AA8TI;EAJF;IAKI,kBAAA;IACA,mBAAA;EA3TJ;AACF;AA6TI;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;AA3TN;AA+TE;EACE,eAAA;AA7TJ;AA+TI;EACE,WAAA;EACA,eAAA;EACA,YAAA;AA7TN;AAiUE;EACE,iBAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;AA/TJ;;AAmUA;EACE,gBAAA;AAhUF;AAkUE;EACE;IACE,kBAAA;EAhUJ;EAsUA;IAEI,kBAAA;EAlUJ;AALF;AA0UI;EACE,2BAAA;EACA,eAAA;AAlUN;AAsUE;EAZF;IAaI,yBAAA;EAnUF;AACF;;AAuUE;EACE,kBAAA;EACA,uBAAA;EACA,gBAAA;AApUJ;AAuUE;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AArUJ;;AA0UE;EACE,2BAAA;AAvUJ;AAyUI;EACE,mBAAA;EACA,0BAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;AAvUN;AA2UM;EACE,kBAAA;AAzUR;AA2UQ;EACE,WAAA;AAzUV;AA4UQ;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;AA1UV;AA4UU;EACE,sBAAA;EACA,0BAAA;AA1UZ;AA4UY;EACE,qBAAA;EACA,eAAA;AA1Ud;AA8UU;EACE,eAAA;AA5UZ;AAgVQ;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AA9UV;AAkVM;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;AAhVR;AAsVI;EACE,iCAAA;EACA,qBAAA;EACA,6BAAA;AApVN;AAsVM;EACE,iCAAA;EACA,wCAAA;AApVR;;AA4VE;EACE,eAAA;AAzVJ;AA2VI;EAHF;IAII,aAAA;EAxVJ;AACF;AA2VE;EACE,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;AAzVJ;AA2VI;EANF;IAOI,aAAA;EAxVJ;AACF;;AA6VE;EACE,uBAAA;AA1VJ;;AAgWE;EACE,gBAAA;AA7VJ;AA+VI;EAHF;IAII,YAAA;EA5VJ;EA+VE;IAEI,SAAA;EA5VN;AAJF;AAoWI;EACE,mBAAA;AA7VN;AA+VM;EAHF;IAII,SAAA;IACA,gBAAA;EA5VN;AACF;AA+VQ;EADF;IAEI,aAAA;IACA,sBAAA;IACA,gCAAA;EA5VR;EAgWI;IAEI,SAAA;EA7VR;EAiWI;IAEI,YAAA;EA9VR;AATF;AA6WI;EA3CF;IA4CI,eAAA;IACA,SAAA;IACA,UAAA;IACA,gBAAA;EAhWJ;AACF;AAmWI;EACE,eAAA;AAjWN;AAmWM;EAHF;IAII,aAAA;EAhWN;AACF;AAkWM;EACE,qBAAA;EACA,YAAA;AAhWR;AAmWM;;;;EAIE,mBAAA;EACA,4BAAA;AAjWR;AAqWI;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;AAnWN;AAqWM;EALF;IAMI,sBAAA;IACA,uBAAA;IACA,aAAA;IACA,mBAAA;EAlWN;AACF;AAoWM;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAlWR;AAoWQ;EAPF;IAQI,eAAA;EAjWR;AACF;AAoWM;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;AAlWR;AAqWM;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAnWR;AAqWQ;EACE,YAAA;EACA,iBAAA;AAnWV;AAuWM;EACE,UAAA;AArWR;AAuWQ;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AArWV;AA0WI;EAEE,eAAA;EACA,uBAAA;EACA,qBAAA;AAzWN;AA2WM;EANF;IAOI,aAAA;EAxWN;AACF;AA0WM;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAxWR;AA4WQ;EACE,8BAAA;AA1WV;AA6WQ;EALF;IAMI,mBAAA;IACA,gBAAA;EA1WR;AACF;AA4WQ;EACE,WAAA;AA1WV;AAgXU;EADF;IAEI,kBAAA;EA7WV;AACF;AA+WU;EACE,iBAAA;AA7WZ;AAiXQ;EACE,kBAAA;AA/WV;AAiXU;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AA/WZ;AAmXY;EADF;IAEI,qBAAA;EAhXZ;AACF;AAkXY;EACE,uCAAA;AAhXd;AAqXQ;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;AAnXV;AAsXQ;EACE,kBAAA;AApXV;AAsXU;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,0BAAA;AApXZ;AAwXQ;EACE,0BAAA;AAtXV;AAwXU;EACE,oCAAA;AAtXZ;AA4XQ;EACE,kBAAA;AA1XV;AA4XU;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,WAAA;AA1XZ;AA6XU;EACE,oBAAA;AA3XZ;AA+XQ;EACE,eAAA;EACA,mBAAA;AA7XV;AAgYQ;EACE,UAAA;AA9XV;AAmYQ;EADF;IAEI,sBAAA;EAhYR;AACF;AAkYQ;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AAhYV;AAkYU;EARF;IASI,qBAAA;EA/XV;AACF;AAmYM;EACE,aAAA;EACA,mBAAA;AAjYR;AAmYQ;EAJF;IAKI,uBAAA;EAhYR;AACF;AAkYQ;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;AAhYV;AAoYM;EACE,kBAAA;AAlYR;AAoYQ;EACE,mDAAA;EACA,qBAAA;AAlYV;AAsYU;EADF;IAEI,WAAA;EAnYV;AACF;AAwYQ;EAhBF;IAiBI,kBAAA;EArYR;AACF;AAyYI;EACE,kBAAA;EACA,gBAAA;AAvYN;AAyYM;EACE,mBAAA;EACA,gBAAA;AAvYR;AA4YM;EADF;IAEI,gBAAA;EAzYN;AACF;AA2YM;EACE,iBAAA;EACA,iBAAA;EACA,YAAA;AAzYR;AA2YQ;EALF;IAMI,WAAA;IACA,cAAA;IACA,mBAAA;EAxYR;AACF;AA4YI;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;AA1YN;AA4YM;EAPF;IAQI,YAAA;IACA,oBAAA;EAzYN;AACF;AA2YM;EACE,WAAA;EACA,YAAA;EACA,cAAA;AAzYR;AA4YM;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;AA1YR;AA6YM;EACE,gBAAA;EACA,2BAAA;AA3YR;AA8YM;EACE,mBAAA;EACA,gBAAA;AA5YR;AA8YQ;EACE,sBAAA;EACA,oBAAA;EACA,qBAAA;AA5YV;AAiZI;EACE,2BAAA;EACA,qBAAA;AA/YN;AAiZM;EAJF;IAKI,gBAAA;EA9YN;EAkZE;IAEI,iBAAA;IACA,gBAAA;IACA,WAAA;EA/YN;EAmZE;IAEI,kBAAA;EAhZN;AAXF;AA+ZI;EACE,YAAA;AAjZN;AAqZE;EACE,SAAA;EACA,kBAAA;AAnZJ;;AAwZE;EACE,YAAA;AArZJ;AAwZM;EACE,gCAAA;EACA,gCAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,0BAAA;AAtZR;AAwZQ;EACE,gCAAA;EACA,gCAAA;EACA,sBAAA;AAtZV;AAyZQ;EAEE,gCAAA;EACA,iCAAA;EACA,iCAAA;AAxZV;;AA+ZA;EACE,sCAAA;AA5ZF;;AA+ZA;EACE,uBAAA;EACA,wCAAA;AA5ZF","sourcesContent":[":root {\n  --p: 0;\n  --b: 2px;\n  --c: var(--red);\n  --w: 16px;\n}\n\n.nav-link.cta-btn:hover,\n.nav-link.cta-btn.active {\n  background: var(--darkSlate);\n  color: var(--white);\n}\n\n.modal-backdrop {\n  display: none;\n}\n\nbody.header-popup-open {\n  .content-wrapper,\n  .prediction-market-page,\n  .prediction-market-layout {\n    pointer-events: none;\n  }\n}\n\nheader.header.header-popup-open {\n  z-index: 2100;\n  pointer-events: auto;\n}\n\nheader {\n  position: relative;\n  // padding: 0 1rem;\n  z-index: 11;\n  // padding-right: 14px;\n  // position: fixed;\n  top: 0;\n  width: 100%;\n  min-height: 55px;\n  left:0;\n  right: 0;\n  // backdrop-filter: blur(3px);\n\n  .header-content {\n    max-width: 1400px;\n    margin: 0 auto;\n  }\n\n  @media screen and (max-width: 575.98px) {\n    min-height: 64px;\n  }\n\n  .brand-logo {\n\n    img {\n      height: 50px;\n    }\n    svg {\n      width: 158px;\n\n      @media screen and (max-width: 1199.98px) {\n        width: 50px;\n        height: 50px;\n      }\n\n      @media screen and (max-width: 768px) {\n        width: 40px;\n        height: 40px;\n      }\n\n      // @media screen and (max-width: 575.98px) {\n      //   width: 32px;\n      //   height: 32px;\n      // }\n    }\n\n    .before-login-logo {\n      width: 158px !important;\n    }\n  }\n\n  .header-middle-btn {\n    gap: 0.5rem;\n    position: absolute;\n    transform: translate(-50%, -50%);\n    left: 50%;\n    top: 50%;\n\n    .cashier-btn {\n      background: linear-gradient(#EFD43C, #CB7D00);\n    }\n\n    @media screen and (max-width: 768px) {\n      position: static;\n      transform: none;\n    }\n\n    @media screen and (max-width: 575.98px) {\n      margin-left: auto;\n    }\n\n    .btn-primary {\n      background: var(--gray-80);\n      border-color: var(--gray-80);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      &:hover {\n        background: var(--sidebarBtnGradient);\n        border: 1px solid var(--gray-60);\n      }\n\n      &.currencies-btn {\n        background: var(--darkGray);\n        border: none;\n        border-radius: 0.5rem;\n        min-height: 2.75rem;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        padding: 0.5rem 1rem;\n\n        &::after {\n          display: none;\n        }\n\n        &:hover {\n          background: var(--gray-80) !important;\n          border-radius: 0.5rem;\n        }\n\n        @media screen and (max-width: 1400px) {\n          border-radius: 6px 0 0 6px;\n\n          &:hover {\n            border-radius: 6px 0 0 6px;\n          }\n        }\n\n        @media screen and (max-width: 575.98px) {\n          padding: 0.25rem 0.5rem;\n          min-height: 2.5rem;\n        }\n      }\n    }\n\n    .buy-crypto {\n      color: var(--gray-20);\n      background-color: var(--gray-80-50);\n      border: none;\n\n      &:hover {\n        color: var(--white);\n        border: none;\n      }\n    }\n  }\n\n  .header-social-links {\n    a {\n      height: 2.75rem;\n      width: 2.75rem;\n      border-radius: 0.625rem;\n      background: var(--gray-80);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n      transition: background-color 0.3s ease 0s;\n\n      svg {\n        transition: fill 0.3s ease 0s;\n      }\n\n      &:not(:last-child) {\n        margin-right: 0.5rem;\n      }\n\n      &:hover {\n        background: var(--gray-60);\n\n        svg {\n          fill: var(--blue-300);\n        }\n      }\n    }\n  }\n\n  &.sidebar-close {\n    .brand-logo {\n      @media only screen and (min-width: 768px) and (max-width: 1480.98px) {\n        margin-left: 0;\n      }\n    }\n  }\n\n  .auth-btn {\n    &.btn-primary {\n      min-width: 120px;\n      // border: 1px solid var(--blue-300);\n      background: linear-gradient(#EFD43C, #CB7D00);\n      color: #ffffff;\n\n      &:hover {\n        // color: var(--blue-100);\n        background: linear-gradient(#EFD43C, #CB7D00) !important;\n        border-color: #CB7D00;\n      }\n\n      @media screen and (max-width: 991.98px) {\n        font-size: 0.875rem;\n      }\n\n      @media screen and (max-width: 767.98px) {\n        min-width: 106px;\n        font-size: 1rem;\n        min-height: 2.5rem;\n      }\n\n      @media screen and (max-width: 575.98px) {\n        min-height: 2rem;\n        font-size: 14px;\n        line-height: 1rem;\n        min-width: auto;\n        padding: 8px 12px;\n      }\n    }\n\n    &.btn-secondary {\n      min-width: 120px;\n      color: #EFD43C;\n      background: transparent;\n      border: 1px solid #CB7D00;\n\n      @media screen and (max-width: 991.98px) {\n        font-size: 0.875rem;\n      }\n\n      @media screen and (max-width: 767.98px) {\n        min-width: 106px;\n        font-size: 1rem;\n        min-height: 2.5rem;\n      }\n\n      @media screen and (max-width: 575.98px) {\n        min-height: 2rem;\n        font-size: 14px;\n        line-height: 1rem;\n        min-width: auto;\n        padding: 8px 12px;\n      }\n    }\n  }\n\n  .search-btn {\n    width: 45px;\n    // display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n\n    & svg {\n      height: 1.2rem;\n      width: 1.2rem;\n    }\n\n    &.btn-primary {\n      background: var(--gray-80);\n      border-color: var(--gray-80);\n      position: relative;\n    }\n\n    .theme-modal {\n      .modal-dialog {\n        position: relative;\n      }\n    }\n  }\n\n  .reward-menu-wrap {\n    .reward-menu {\n      min-width: 415px;\n      left: -60% !important;\n      overflow-x: hidden;\n      overflow-y: auto;\n      min-height: 310px;\n      padding: 1.5rem 1.5rem 0 1.5rem;\n      margin-bottom: 0;\n\n      @media screen and (max-width: 767.98px) {\n        min-width: 360px;\n      }\n\n      li {\n        margin-bottom: 0.75rem;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n\n      .dropdown-item {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        background: transparent;\n        padding: 0.313rem 0;\n\n        &:hover {\n          background: transparent;\n\n          img {\n            filter: none;\n          }\n        }\n\n        .reward-menu-content {\n          h4 {\n            font-size: 0.875rem;\n            text-transform: uppercase;\n            padding-bottom: 0.1rem;\n          }\n\n          p {\n            font-size: 0.75rem;\n            font-weight: 300;\n            color: var(--live-green);\n          }\n        }\n\n        .btn {\n          height: auto;\n          padding: 0.2rem 1rem;\n          font-size: 0.75rem;\n\n          & svg {\n            width: 1rem;\n            height: 1rem;\n            margin-right: 0.313rem;\n          }\n\n          &.btn-green {\n            background: var(--live-green);\n\n            &:hover {\n              background: transparent;\n              border-color: var(--blue-300);\n            }\n          }\n        }\n\n        .reward-menu-icon {\n          margin-right: 0.313rem;\n\n          & svg {\n            height: 3rem;\n            width: 3rem;\n            margin: 0;\n          }\n        }\n      }\n\n      .reward-list {\n        background-color: var(--gray-85);\n        padding: .75rem 1rem;\n        border-radius: 0.5rem;\n\n        .bonus-type {\n          display: flex;\n          align-items: center;\n          gap: 1rem;\n\n          p {\n            margin: 0;\n            font-size: 0.875rem;\n            font-weight: 700;\n            color: var(--white);\n          }\n\n          img {\n            width: 44px;\n          }\n        }\n\n        .bonus-btn {\n          button {\n            min-height: 2.5rem;\n            padding: 0.25rem 1rem !important;\n            justify-content: center;\n            display: flex;\n            align-items: center;\n\n            @media screen and (max-width: 767.98px) {\n              min-width: 110px !important;\n              font-size: 0.875rem;\n            }\n\n            span {\n              display: flex;\n              align-items: center;\n            }\n\n            svg {\n              width: 1rem;\n              height: 1rem;\n              margin-right: 0.313rem;\n            }\n          }\n        }\n      }\n\n      .dropdown-btn-wrap {\n        .btn-primary {\n          background: var(--gray-80);\n\n          &:hover {\n            background: var(--secondaryRadialBtn);\n            border-color: var(--secondaryBtnBorder);\n          }\n        }\n      }\n    }\n\n    .view-dashboard {\n      color: var(--gray-20);\n      font-size: 1rem;\n      font-weight: 500;\n\n      &:hover {\n        color: var(--white);\n      }\n    }\n  }\n\n  .provider-list {\n    .casino-search {\n      background: transparent;\n\n      & .search-icon {\n        top: 0.9rem;\n      }\n\n      & input {\n        box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.19) !important;\n      }\n    }\n  }\n\n  .header-toggle-icon,\n  .header-user-menu {\n    margin-left: 6rem;\n\n    @media screen and (max-width: 767.98px) {\n      margin-left: 0.5rem;\n    }\n\n  }\n\n  .reward-btn {\n    .btn-primary {\n      padding: 0.625rem 0.5rem;\n      background: var(--gray-85);\n      border: none;\n      &:hover, &:focus {\n        background-color: #000000 !important;\n      }\n\n      .dropdown-icon {\n        width: 24px;\n        height: 24px;\n        color: var(--gray-20);\n        border-radius: 0.5rem;\n        background: var(--gray-80);\n        line-height: 1.6;\n      }\n\n      &:hover,\n      &:focus {\n        .dropdown-icon {\n          background-color: var(--gray-80);\n        }\n      }\n\n      @media screen and (max-width: 767.98px) {\n        padding: 0.25rem 0.5rem;\n      }\n\n      @media screen and (max-width: 575.98px) {\n        min-height: 2.5rem;\n        //  height: 2rem;\n        width: 2.5rem;\n        padding: 6px;\n\n        svg {\n          width: 22px;\n        }\n      }\n    }\n  }\n\n  .reward-btn.show {\n    .dropdown-icon {\n      background-color: var(--gray-80) !important;\n    }\n  }\n\n  .account-btn:hover .dropdown-icon {\n    background-color: var(--gray-80) !important;\n  }\n\n  .top-header-right {\n    display: flex;\n\n    .btn-primary {\n      position: relative;\n\n      svg {\n        position: absolute;\n        transform: translate(-50%, -50%);\n\n        &:nth-child(2) {\n          opacity: 0;\n        }\n      }\n\n      &.active {\n        background: var(--gray-60) !important;\n\n        svg {\n          fill: var(--blue-300);\n        }\n      }\n\n      &:hover {\n        background: var(--gray-60) !important;\n\n        svg {\n          fill: var(--blue-300);\n        }\n      }\n    }\n  }\n}\n\n.search-dilog {\n  max-width: 1408px;\n\n  .search-modal {\n    background-color: var(--darkGray) !important;\n\n    .search-modal-wrap {\n      padding: 2rem;\n\n      @media screen and (max-width: 1199.98px) {\n        padding: 2rem 2rem 5rem 2rem;\n      }\n\n      .nav-link {\n        background: var(--gray-85);\n        min-width: 100%;\n        width: 100%;\n        margin: 0;\n        justify-content: flex-start;\n        border: none;\n        font-size: 0.875rem;\n        font-weight: 500;\n        border-radius: 0;\n        padding: 0.6rem 1rem;\n        min-height: 2.5rem;\n\n        &.active,\n        &:hover {\n          background: var(--gray-90);\n\n          & img {\n            filter: brightness(10);\n          }\n        }\n\n        & img {\n          margin-right: 0.8rem;\n          width: 1rem;\n        }\n      }\n\n      .search-modal-right-section {\n        @media screen and (max-width: 767.98px) {\n          padding: 0;\n        }\n\n        .search-modal-heading {\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          margin-bottom: 1rem;\n\n          h4 {\n            color: var(--white);\n            margin: 0;\n            font-weight: 700;\n            text-transform: uppercase;\n            font-size: 1.375rem;\n          }\n        }\n\n        .casino-search {\n          flex: 1;\n          margin-right: 0;\n\n          input {\n            height: 48px;\n          }\n        }\n\n        .search-filter-right {\n          .btn-primary {\n            font-size: 0.875rem;\n            min-height: 48px;\n            background: var(--gray-80);\n            border-color: var(--gray-80);\n            color: var(--gray-20);\n            cursor: pointer;\n            padding: 0.25rem 1.125rem;\n\n            span {\n              color: var(--white);\n            }\n\n            &:after {\n              margin-left: 1rem !important;\n              transition: transform 0.3s;\n            }\n\n            &.show,\n            &:visited {\n              background: var(--gray-80) !important;\n              border-color: var(--gray-80) !important;\n\n              &:after {\n                transform: rotate(180deg);\n              }\n            }\n          }\n\n          @media screen and (max-width: 767.98px) {\n\n            & .btn {\n              width: 100%;\n            }\n          }\n\n        }\n\n        .global-casino-section {\n          padding: 0 0.625rem;\n\n          // margin: 1rem 0;\n          .theme-card-wrap {\n            margin: 0.5rem 0;\n            width: 100%;\n            min-width: 100%;\n          }\n        }\n\n        .load-more-wrap {\n          .btn {\n            @media screen and (max-width: 767.98px) {\n              justify-content: center;\n            }\n          }\n        }\n\n        .global-casino-section {\n          .col-lg-2 {\n            @media screen and (min-width: 1200px) {\n              width: 14.285%;\n            }\n          }\n        }\n      }\n\n      .profile-tabs {\n        position: sticky;\n        top: 1rem;\n        background: var(--gray-85);\n        border-radius: 0.625rem;\n        padding: 0;\n        overflow: hidden;\n        max-width: 190px;\n        margin-right: 2rem;\n      }\n    }\n  }\n}\n\n.auth-modal-wrap {\n  @media screen and (max-width: 1199.98px) {\n    min-width: 80%;\n  }\n}\n\n@media screen and (max-width: 767.98px) {\n  .currency-wrapper .btn-wallet {\n    padding: 4px 11px;\n  }\n}\n\nheader .menuBtn {\n  display: none;\n  z-index: 1;\n}\n\nheader .menuBtn.toggleBtn {\n  transform: scaleX(-1);\n}\n\n.chat-sidebar {\n  position: fixed;\n  right: 0;\n  top: 4.75rem;\n  background: var(--gray-90);\n  height: calc(100dvh - 50px);\n  width: 248px;\n  border-left: 1px solid var(--gray-80);\n  transition: all 0.4s ease-in-out;\n\n  @media screen and (max-width: 575.98px) {\n    top: 4rem;\n  }\n\n  & .chat-content {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  &.chat-collapse {\n    width: 352px;\n\n    @media screen and (max-width: 767.98px) {\n      width: 100%;\n    }\n\n    .chat-collapse-icon {\n      transform: rotate(180deg);\n\n      svg {\n        position: absolute;\n        transform: translate(-50%, -50%);\n        top: 50%;\n        left: 50%;\n      }\n    }\n\n    .btn-secondary {\n      min-width: 110px;\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    width: 100%;\n  }\n\n  .chat-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid var(--gray-80);\n    padding: 1rem;\n    margin-bottom: 1rem;\n\n    .chat-btn {\n      background: var(--gray-60) !important;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .language-btn {\n      a {\n        color: var(--white);\n        font-weight: 600;\n        font-size: 0.75rem;\n        display: flex;\n        align-items: center;\n\n        i {\n          font-size: 1rem;\n        }\n      }\n\n      button {\n\n        &:hover,\n        &:active {\n          background: var(--gray-60) !important;\n        }\n      }\n    }\n\n    // .chat-close-wrap {\n    //   width: 60px;\n    // }\n\n    .btn-primary {\n      background: transparent;\n      border: none;\n      width: 100%;\n      font-size: 0.875rem;\n      padding: 0 0.5rem;\n      box-shadow: none;\n      color: var(--gray-20);\n      min-height: 2.25rem;\n      font-weight: 500;\n\n      & svg {\n        margin-right: 0.3125rem;\n        height: 1.125rem;\n      }\n\n      svg,\n      path {\n        transition: fill 0.3s ease 0s;\n      }\n\n      &.active,\n      &:hover {\n        border-color: transparent;\n        background: transparent;\n        color: var(--white);\n\n        svg,\n        path {\n          fill: var(--blue-300);\n        }\n      }\n    }\n\n    .btn-secondary {\n      height: 2.375rem;\n      width: 100%;\n      font-size: 0.74rem;\n      margin: 0 0.313rem;\n      padding: 0.25rem 0.625rem;\n      box-shadow: none;\n\n      @media screen and (max-width: 767.98px) {\n        min-width: 140px;\n      }\n\n      &.active,\n      &:hover {\n        border-color: var(--blue-300);\n        background: transparent;\n        color: var(--white);\n      }\n    }\n\n    & > a {\n      width: 100%;\n      color: var(--white);\n      text-align: center;\n      font-size: 0.74rem;\n      background: var(--gray-85);\n      min-height: 2.375rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 0.625rem;\n      margin: 0 0.313rem;\n      border: 1px solid var(--gray-85);\n\n      &.active,\n      &:hover {\n        background: var(--darkGray);\n        border-color: var(--secondaryBtnBorder);\n        color: var(--secondaryBtnBorder);\n      }\n    }\n\n    .chat-close {\n      background: transparent;\n      padding: 0;\n      // margin: 0 0.2rem;\n      // width: 1.5rem;\n      // flex: 0 0 1.5rem;\n      align-items: center;\n      display: flex;\n      justify-content: center;\n      border: none;\n      position: relative;\n      color: var(--gray-20);\n\n      &.active,\n      &:hover {\n        background: transparent;\n        border-color: transparent;\n        color: var(--blue-300);\n      }\n    }\n\n    .chat-collapse-icon {\n      background: transparent;\n      padding: 0;\n      margin: 0 0.2rem;\n      width: 5rem;\n      align-items: center;\n      display: flex;\n      justify-content: center;\n      border: none;\n      // flex: 0 0 2rem;\n      position: relative;\n\n      &.active,\n      &:hover {\n        background: transparent;\n        border-color: transparent;\n\n        svg {\n          path:nth-child(1) {\n            stroke: var(--blue-300);\n          }\n\n          path:nth-child(2) {\n            fill: var(--blue-300);\n          }\n        }\n      }\n\n      @media screen and (max-width: 991.98px) {\n        display: none;\n      }\n    }\n\n    .dropdown-toggle {\n      &::after {\n        display: inline-block;\n      }\n    }\n\n    .dropdown-menu {\n      min-width: 100%;\n      padding: 0.25rem;\n      border-radius: 0.5rem;\n\n      a {\n        display: flex;\n        align-items: center;\n        font-size: 0.875rem;\n        gap: 0.75rem;\n        width: 128px;\n        padding: 0.25rem 0.5rem;\n        border-radius: 0.25rem;\n        font-weight: 400;\n\n        img {\n          width: 18px;\n          object-fit: cover;\n        }\n      }\n    }\n  }\n\n  .chat-announcement-card {\n    background: var(--blue-300);\n    border-radius: 0.313rem;\n    margin-bottom: 0.25rem;\n    padding: 0.625rem;\n    position: relative;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    p {\n      color: var(--white);\n      font-size: 0.75rem;\n      margin: 0;\n      padding-right: 0.4rem;\n      line-height: 1.3;\n      word-break: break-all;\n    }\n\n    a {\n      color: var(--white);\n      font-size: 0.625rem;\n    }\n  }\n\n  .chat-content-scroll {\n    // height: calc(100vh - 250px);\n    // overflow-y: auto;\n    // margin-bottom: 22px;\n    // border-bottom: 2px solid var(--gray-80);\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 0%;\n    min-height: 0px;\n    overflow-wrap: break-word;\n    overflow: hidden auto;\n    margin-bottom: 30px;\n    border-bottom: 2px solid var(--gray-80);\n\n    @media screen and (max-width: 1199.98px) {\n      height: calc(100vh - 315px);\n    }\n\n    @media screen and (max-width: 767.98px) {\n      height: calc(100vh - 315px);\n    }\n\n    .empty-chat {\n      width: 100%;\n      padding: 5px;\n    }\n\n    .chat-content-wrap {\n      padding: 1rem 1rem 0.5rem 1rem;\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      position: relative;\n\n      .chat-bubble:nth-child(1) {\n        margin-top: auto;\n      }\n\n      .new_message {\n        color: #00a4fa;\n        text-align: center;\n      }\n\n      .new_message::before {\n        background-color: #00a4fa;\n        content: \"\";\n        display: inline-block;\n        height: 1px;\n        position: relative;\n        vertical-align: middle;\n        width: 100%;\n      }\n\n      .new_message::before {\n        right: 0.5em;\n        margin-left: -50%;\n      }\n\n      @media screen and (max-width: 767.98px) {\n        width: 100%;\n        height: calc(100vh - 260px);\n      }\n\n      .chat-card {\n        margin: 0.5rem 0;\n        border-radius: 0.5rem;\n        background: var(--gray-80-50);\n        padding: 0.75rem;\n        color: var(--white);\n        word-break: break-word;\n        position: relative;\n\n        &:hover {\n          background: var(--gray-80);\n        }\n\n        h4 {\n          font-weight: 600;\n          padding-right: 0.313rem;\n          cursor: pointer;\n        }\n\n        p {\n          span {\n            // opacity: 0.8;\n            font-weight: 400;\n          }\n\n          .tagged-name {\n            color: var(--white);\n            font-weight: 400;\n          }\n\n          .chat-msg {\n            color: var(--gray-10);\n          }\n        }\n\n        .user-icon {\n          width: 1rem;\n          margin-right: 0.313rem;\n        }\n\n        &:first-child {\n          margin-top: auto;\n        }\n\n        .chat-card-head {\n          .chat-badge-lising {\n            margin: 0 0.1rem;\n            display: flex;\n\n            svg {\n              margin: 0 0.1rem;\n            }\n          }\n\n          .chat-avtar {\n            img {\n              object-fit: cover;\n              border-radius: 12px;\n            }\n          }\n\n          .user-clr-one {\n            // color: var(--white);\n            // position: relative;\n            // top: -2px;\n            // margin-right: 4px;\n            margin-bottom: 0;\n\n            img {\n              object-fit: cover;\n              border-radius: 12px;\n            }\n\n            .mod-badge {\n              font-weight: 600;\n              font-size: 12px;\n              border-radius: 4px;\n              margin-right: 4px;\n              color: var(--darkGray);\n              line-height: 18px;\n              min-height: 18px;\n              width: 35px;\n              padding: 0 4px;\n              display: inline-block;\n              cursor: pointer;\n            }\n\n            .chat-user-label {\n              // display: inline-block;\n              vertical-align: middle;\n              // max-width: 70px;\n              font-weight: 600;\n              font-size: 0.875rem;\n              color: var(--white);\n            }\n\n            .gif_img {\n              pointer-events: none;\n              cursor: default;\n              height: 60px;\n              // height: 50%;\n            }\n          }\n\n          .gif-chat-box {\n            display: flex;\n            align-items: center;\n\n            .chat-user-label {\n              white-space: nowrap;\n            }\n\n            .gif_img {\n              max-width: 75px;\n              // width: 50%;\n            }\n          }\n        }\n\n        .chat-time {\n          font-size: 0.625rem;\n          font-weight: 300;\n          color: var(--gray-20);\n        }\n\n        .chat-text {\n          color: var(--gray-10-80);\n          word-break: break-all;\n          font-size: 0.875rem;\n          line-height: 26px;\n        }\n\n        .report-user-wrap {\n          padding: 0.2rem;\n          min-width: 32px;\n          min-height: 30px;\n          align-items: center;\n          justify-content: center;\n          position: absolute;\n          right: 0.313rem;\n          top: 0;\n          display: none;\n          cursor: pointer;\n        }\n\n        &:hover {\n          .report-user-wrap {\n            display: flex;\n          }\n        }\n      }\n    }\n\n    &::-webkit-scrollbar {\n      width: 0;\n    }\n  }\n\n  .chat-bottom-section {\n    padding: 1rem;\n    position: relative;\n    top: -1.875rem;\n\n    @media screen and (max-width: 1199.98px) {\n      padding: 1rem 1rem 5.25rem 1rem;\n    }\n\n    .chat-typing {\n      position: relative;\n\n      textarea {\n        background-color: var(--darkGray) !important;\n        // height: 2.75rem !important;\n        font-size: 0.875rem !important;\n        border: 2px solid var(--gray-80) !important;\n        padding-right: 4.375rem !important;\n        border-radius: 0.5rem;\n        margin-bottom: 0.625rem;\n        color: var(--gray-40);\n        font-family: \"Rubik\", sans-serif !important;\n        // top: -0.925rem !important;\n        // max-height: 10rem;\n        // overflow: auto;\n\n        &:focus {\n          outline: none;\n          color: var(--white);\n\n          // border-color: var(--primaryBtnBorder) !important;\n          &::placeholder {\n            color: var(--white) !important;\n          }\n        }\n      }\n\n      div {\n        .giphy-carousel {\n          width: 285px;\n          position: absolute;\n          bottom: 79px;\n          right: 0;\n\n          .giphy-gif {\n            width: 100px !important;\n            height: 100px !important;\n          }\n\n          .giphy-attribution {\n            display: none !important;\n          }\n        }\n\n        button {\n          border: 1px solid transparent;\n          background-color: transparent !important;\n        }\n      }\n\n      .chat-input-cta {\n        position: absolute;\n        z-index: 1;\n        right: 0.625rem;\n        bottom: 0.5rem;\n\n        svg {\n          cursor: pointer;\n          margin: 0 0.2rem;\n        }\n      }\n    }\n\n    .chat-details-wrap {\n      margin-top: 0.625rem;\n\n      & .btn {\n        min-height: 1.688rem;\n        padding: 0 0.5rem;\n        font-size: 0.74rem;\n        border-radius: 0.375rem;\n        // margin-left: 0.313rem;\n      }\n\n      & img {\n        margin-right: 0.313rem;\n        width: 1rem;\n        height: 1rem;\n        border-radius: 1rem;\n      }\n\n      a {\n        color: var(--gray-10);\n        font-weight: 400;\n        font-size: 0.875rem;\n        display: flex;\n        gap: 8px;\n        padding: 0.45rem;\n        align-items: center;\n        width: 8rem;\n        height: 2rem;\n\n        i {\n          font-size: 1rem;\n        }\n      }\n\n      & .dropdown-item {\n        & img {\n          margin-right: 0;\n        }\n      }\n\n      .chat-rules {\n        background-color: var(--gray-80);\n        padding: 7px;\n        border-radius: 4px;\n        width: auto;\n\n        &:focus {\n          background: var(--gray-60);\n\n          svg {\n            path {\n              stroke: var(--blue-300);\n            }\n          }\n        }\n      }\n\n      ul {\n        background-color: var(--gray-80);\n        padding: 12px !important;\n        min-width: 9rem;\n        border-radius: 0.5rem;\n        border: none;\n        box-shadow: var(--dropdownShadow);\n\n        li {\n          border-radius: 4px;\n\n          &:hover {\n            background: var(--gray-60);\n\n            a {\n              color: var(--gray-10);\n\n              &:hover {\n                background: transparent;\n                color: var(--white);\n              }\n            }\n          }\n        }\n      }\n\n      .progress-wrap {\n        border: 2px solid var(--c);\n        border-radius: 50%;\n        height: 14px;\n        width: 14px;\n        margin-right: 6px;\n\n        .pie {\n          width: var(--w);\n          aspect-ratio: 1;\n          position: relative;\n          display: inline-grid;\n          // margin:5px;\n          place-content: center;\n          font-size: 25px;\n          font-weight: bold;\n          font-family: sans-serif;\n        }\n\n        .pie:before,\n        .pie:after {\n          content: \"\";\n          position: absolute;\n          border-radius: 50%;\n        }\n\n        .pie:before {\n          inset: 2px;\n          background: radial-gradient(farthest-side, var(--c) 98%, #0000) top/var(--b) var(--b) no-repeat,\n            conic-gradient(var(--c) calc(var(--p) * 1%), #0000 0);\n          -webkit-mask: radial-gradient(farthest-side,\n              #0000 calc(99% - var(--b)),\n              #000 calc(100% - var(--b)));\n          mask: radial-gradient(farthest-side,\n              #0000 calc(99% - var(--b)),\n              #000 calc(100% - var(--b)));\n        }\n\n        .pie:after {\n          inset: calc(50% - var(--b) / 2);\n          background: var(--c);\n          transform: rotate(calc(var(--p) * 3.6deg)) translateY(calc(50% - var(--w) / 2));\n        }\n\n        .animate {\n          animation: p 1s 0.5s both;\n        }\n\n        .no-round:before {\n          background-size: 0 0, auto;\n        }\n\n        .no-round:after {\n          content: none;\n        }\n\n        @keyframes p {\n          from {\n            --p: 0;\n          }\n        }\n      }\n\n      .text-limit {\n        width: 25px;\n        font-size: 0.875rem;\n      }\n\n      .btn-primary {\n        font-weight: 400 !important;\n        font-size: 0.875rem !important;\n        min-height: 2rem;\n        min-width: 100px;\n\n        &:hover,\n        &:focus,\n        &:active {\n          background: var(--gray-60) !important;\n          border-color: var(--gray-60) !important;\n          color: var(--white);\n        }\n      }\n\n      .btn-secondary {\n        font-weight: 500 !important;\n        font-size: 1rem !important;\n        max-width: 56px;\n        min-width: 56px;\n        min-height: 32px;\n      }\n\n      .dropdown-toggle {\n        &::after {\n          margin-left: 0.5rem;\n        }\n      }\n    }\n\n    .gif-input {\n      height: 2rem !important;\n      width: 80%;\n      margin: 0 auto 0.25rem !important;\n    }\n  }\n}\n\n.user-profile-modal {\n  .modal-body {\n    padding: 0.625rem !important;\n  }\n\n  .btn-close {\n    background-color: var(--gray-60) !important;\n    border: 2px solid var(--gray-90) !important;\n    opacity: 1 !important;\n  }\n\n  .modal-content {\n    @media screen and (max-width: 1199.98px) {\n      margin-bottom: 5rem;\n    }\n\n  }\n}\n\n.chat-modal {\n  color: var(--white);\n\n  .btn-close {\n    position: absolute;\n    height: 1rem;\n    width: 1rem;\n    right: 0.313rem;\n    top: 0.313rem;\n    border-radius: 100%;\n    background: var(--gray-80);\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    @media screen and (max-width: 767.98px) {\n      right: 0.625rem;\n      top: 0.625rem;\n    }\n\n    &:hover {\n      opacity: 1;\n    }\n\n    svg {\n      width: 0.625rem;\n      height: 0.625rem;\n    }\n  }\n\n  .modal-dialog {\n    max-width: 442px;\n\n    @media screen and (max-width: 767.98px) {\n      max-width: 100%;\n      margin: 0;\n    }\n  }\n\n  .chat-modal-header-wrap {\n    background: var(--gray-80-50);\n    border-radius: 0.625rem;\n    margin-bottom: 0.5rem;\n\n    h4 {\n      text-transform: capitalize;\n      margin: 0;\n      padding-right: 1rem;\n      font-size: 1.125rem;\n      font-weight: 600;\n    }\n\n    .tip-btn {\n      height: 1.5rem;\n      min-height: 1.5rem;\n      background: var(--gray-80);\n      border: 1px solid var(--blue-300);\n      border-radius: 0.5rem;\n      color: var(--white);\n      font-size: 0.75rem;\n      font-weight: 600;\n      line-height: 1.5rem;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      padding: 0 0.5rem 0 0.313rem;\n      margin-right: 0.75rem;\n\n      & img {\n        width: 0.938rem;\n        height: 0.938rem;\n      }\n    }\n\n    .edit-btn {\n      min-height: unset;\n      height: 1.5rem;\n      width: 1.5rem;\n      border: 1px solid var(--gray-60);\n      border-radius: 0.5rem;\n      color: var(--gray-40);\n      font-size: 0.875rem;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      padding: 0;\n      margin: 0 0 0 auto;\n\n      i {\n        font-size: 13px;\n      }\n    }\n\n    .chat-modal-header-right {\n      flex: 1;\n\n      .progress {\n        height: 6px;\n      }\n    }\n  }\n\n  .chat-modal-content {\n    background: var(--gray-80-50);\n    border-radius: 0.5rem;\n    margin-top: 0.5rem;\n    padding: 1rem;\n\n    .chat-bets-wrap {\n      column-gap: 1rem;\n      row-gap: 0.5rem;\n\n      @media screen and (max-width: 575.98px) {\n        column-gap: .5rem;\n        row-gap: 0.25rem;\n      }\n    }\n\n    .chat-bets {\n      flex: 0 0 calc(50% - 1rem + (1rem / 2));\n      max-width: calc(50% - 1rem + (1rem / 2));\n      font-size: 0.875rem;\n      font-weight: 500;\n      line-height: 1;\n\n      h4 {\n        font-size: 0.875rem;\n        font-weight: 500;\n        line-height: 1;\n        color: var(--gray-40);\n\n        @media screen and (max-width: 575.98px) {\n          line-height: 18px;\n          font-size: 0.75rem;\n        }\n      }\n\n      p {\n        padding-left: 0.313rem;\n        font-size: 0.875rem;\n        font-weight: 500;\n        line-height: 1;\n        color: var(--white);\n\n        @media screen and (max-width: 575.98px) {\n          line-height: 18px;\n          font-size: 0.75rem;\n        }\n      }\n    }\n  }\n\n  .progrees-content {\n    p {\n      font-size: 0.875rem;\n      color: var(--gray-40);\n      font-weight: 500;\n\n      span {\n        color: var(--live-green);\n        padding: 0 0.2rem;\n        font-weight: 600;\n      }\n    }\n  }\n\n  .favourites-game-wrap {\n    margin-right: 1rem;\n\n    .favourites-game-img {\n      height: 78px;\n      width: 78px;\n      border-radius: 0.313rem;\n      overflow: hidden;\n      margin-right: 1rem;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: fill;\n      }\n    }\n\n    .favourites-game-right {\n      p {\n        font-size: 0.75rem;\n        color: var(--gray-20);\n        font-weight: 600;\n      }\n\n      h4 {\n        color: var(--white);\n        font-size: 1rem;\n        max-width: 140px;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        font-weight: 700;\n      }\n    }\n  }\n\n  .chat-modal-profile-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    // gap: 0.75rem;\n\n    .chat-modal-header-details {\n      display: flex;\n      width: 100%;\n      padding-right: 1rem;\n    }\n\n    @media screen and (max-width: 575px) {\n      flex-direction: column;\n      gap: 20px;\n      padding-bottom: 1rem;\n    }\n  }\n\n  .chat-modal-profile-img {\n    padding: 1rem;\n    border-right: 1px solid var(--gray-80);\n\n    @media screen and (max-width: 575.98px) {\n      border-right: none;\n      padding: 1rem 0 0 0;\n    }\n\n    img {\n      flex: 0 0 5rem;\n      max-width: 5rem;\n      height: 5rem;\n      border-radius: 50%;\n      object-fit: cover;\n      object-position: center;\n    }\n  }\n\n  .chat-modal-header-left {\n    width: 4.375rem;\n\n    & img {\n      width: 100%;\n      max-width: 62px;\n      height: auto;\n    }\n  }\n\n  .modal-body {\n    padding: 0.625rem;\n    background: var(--gray-90);\n    border-radius: 1rem;\n    border: 1px; //solid var(--gray-80)\n  }\n}\n\n.account-btn-mid-content {\n  font-weight: 600;\n\n  @media screen and (max-width: 767.98px) {\n    p {\n      font-size: 0.74rem;\n    }\n  }\n}\n\n.btn {\n  &.balance-btn {\n    @media screen and (max-width: 767.98px) {\n      font-size: 0.74rem;\n    }\n\n    &:hover {\n      background: var(--darkGray);\n      cursor: default;\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 0.25rem 0.625rem;\n  }\n}\n\n.chat-modal-wrap {\n  .modal-dialog {\n    position: relative;\n    border-radius: 0.625rem;\n    min-width: 620px;\n  }\n\n  .btn-close {\n    filter: invert(10);\n    opacity: 1;\n    width: 0.625rem;\n    background-size: 0.625rem;\n    right: 0.313rem;\n    top: 0.313rem;\n    position: absolute;\n    z-index: 1;\n    box-shadow: none;\n  }\n}\n\n.upload-modal {\n  .modal-dialog {\n    max-width: 468px !important;\n\n    .btn-close {\n      border-radius: 100%;\n      background: var(--gray-80);\n      opacity: 1;\n      top: 1.5rem;\n      right: 1.5rem;\n    }\n\n    .profile-pic-wrapper {\n      .image-upload-box {\n        position: relative;\n\n        svg {\n          width: 45px;\n        }\n\n        .drop-title {\n          margin-bottom: 0;\n          font-weight: 500;\n          font-size: 0.875rem;\n\n          span {\n            color: var(--blue-300);\n            text-decoration: underline;\n\n            &:hover {\n              text-decoration: none;\n              cursor: pointer;\n            }\n          }\n\n          ::-webkit-file-upload-button {\n            cursor: pointer;\n          }\n        }\n\n        .drop-limit {\n          margin-bottom: 0;\n          font-weight: 400;\n          font-size: 0.875rem;\n          color: var(--gray-40);\n        }\n      }\n\n      input[type=\"file\"] {\n        position: absolute;\n        top: -2px;\n        height: 20px;\n        right: 0;\n        width: 50px;\n        cursor: pointer;\n        opacity: 0;\n      }\n    }\n  }\n\n  .modal-footer {\n    .btn-primary {\n      border: 1px solid var(--blue-300);\n      color: var(--blue-50);\n      background-color: transparent;\n\n      &:hover {\n        border: 1px solid var(--blue-100);\n        background-color: transparent !important;\n      }\n    }\n  }\n}\n\n.tip-modal {\n\n  .modal-content {\n    padding: 1.5rem;\n\n    @media screen and (max-width: 767.98px) {\n      padding: 1rem;\n    }\n  }\n\n  &-body {\n    margin-top: 1.5rem;\n    background-color: var(--gray-85);\n    border-radius: 8px;\n    padding: 1.5rem;\n\n    @media screen and (max-width: 767.98px) {\n      padding: 1rem;\n    }\n  }\n}\n\n#profile-pic-modal {\n  .modal-footer {\n    background: transparent;\n  }\n}\n\n.cashier-modal {\n\n  .modal-dialog {\n    min-width: 805px;\n\n    @media screen and (max-width: 767.98px) {\n      height: 100%;\n    }\n\n    .btn-close {\n      @media screen and (max-width: 767.98px) {\n        top: 25px;\n      }\n    }\n\n    .modal-content {\n      border-radius: 12px;\n\n      @media screen and (max-width: 1024.98px) {\n        border: 0;\n        border-radius: 0;\n      }\n\n      .modal-body {\n        @media screen and (max-width: 767.98px) {\n          display: flex;\n          flex-direction: column;\n          background-color: var(--gray-90);\n        }\n      }\n\n      .tab-content {\n        @media screen and (max-width: 767.98px) {\n          flex: 1;\n        }\n      }\n\n      .tab-pane {\n        @media screen and (max-width: 767.98px) {\n          height: 100%;\n        }\n      }\n\n    }\n\n    @media screen and (max-width: 1024.98px) {\n      min-width: 100%;\n      margin: 0;\n      padding: 0;\n      border-radius: 0;\n      // height: 100%;\n    }\n\n    .modal-body {\n      padding: 1.5rem;\n\n      @media screen and (max-width: 1024.98px) {\n        padding: 1rem;\n      }\n\n      .nav-link {\n        color: var(--gray-40);\n        opacity: 0.8;\n      }\n\n      .nav-tabs .nav-item .nav-link:hover,\n      .nav-tabs .nav-item .nav-link.active,\n      .nav-pills .nav-item .nav-link:hover,\n      .nav-pills .nav-item .nav-link.active {\n        color: var(--white);\n        border-color: var(--gray-80);\n      }\n    }\n\n    .cashier-heading {\n      margin-bottom: 1.5rem;\n      display: flex;\n      align-items: center;\n\n      @media screen and (max-width: 767.98px) {\n        flex-direction: column;\n        align-items: flex-start;\n        row-gap: 1rem;\n        margin-bottom: 1rem;\n      }\n\n      h3 {\n        display: flex;\n        align-items: center;\n        font-size: 1.25rem;\n        color: var(--white);\n        font-weight: 700;\n\n        @media screen and (max-width: 767.98px) {\n          font-size: 1rem;\n        }\n      }\n\n      a {\n        color: var(--blue-300);\n        font-size: 1rem;\n        padding-left: 1rem;\n        font-weight: 500;\n        line-height: 1;\n        text-decoration: underline;\n      }\n\n      .currency-icon {\n        height: 30px;\n        width: 30px;\n        border-radius: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-right: 0.625rem;\n\n        img {\n          height: 100%;\n          object-fit: cover;\n        }\n      }\n\n      .left-arrow {\n        padding: 0;\n\n        svg {\n          filter: brightness(10);\n          width: 1rem;\n          height: 1rem;\n          margin-right: 1rem;\n        }\n      }\n    }\n\n    .modal-inner-card {\n      // background: var(--gray-85);\n      padding: 1.5rem;\n      border-radius: 0.625rem;\n      color: var(--gray-20);\n\n      @media screen and (max-width: 767.98px) {\n        padding: 1rem;\n      }\n\n      p {\n        margin-bottom: 0;\n        padding-right: 2rem;\n        line-height: 1.6;\n        color: var(--gray-20);\n        font-size: 1rem;\n        font-weight: 400;\n        font-style: normal;\n      }\n\n      .qr-code {\n        canvas {\n          border: 5px solid var(--white);\n        }\n\n        @media screen and (max-width: 767.98px) {\n          margin-bottom: 1rem;\n          margin-top: 1rem;\n        }\n\n        img {\n          width: 100%;\n        }\n      }\n\n      .change-username {\n        label {\n          @media screen and (max-width: 767.98px) {\n            font-size: 0.75rem;\n          }\n\n          span {\n            color: var(--red);\n          }\n        }\n\n        .form-group {\n          position: relative;\n\n          .btn-secondary {\n            position: absolute;\n            right: 0.35rem;\n            top: 0.375rem;\n            min-height: 2.25rem;\n            font-size: 0.813rem;\n            display: flex;\n            align-items: center;\n          }\n\n          .form-control {\n            @media screen and (max-width: 767.98px) {\n              padding-right: 5.7rem;\n            }\n\n            &:focus {\n              border-color: var(--secondaryBtnBorder);\n            }\n          }\n        }\n\n        p {\n          color: var(--white);\n          text-transform: uppercase;\n          font-size: 0.875rem;\n          line-height: 1.75rem;\n          font-weight: 700;\n        }\n\n        .form-text-wrap {\n          margin: 0.313rem 0;\n\n          p {\n            font-size: 0.75rem;\n            font-weight: 500;\n            line-height: 1.063;\n            color: var(--gray-40);\n            text-transform: capitalize;\n          }\n        }\n\n        .btn-primary {\n          background: var(--gray-80);\n\n          &:hover {\n            background: var(var(--secondaryBtn));\n          }\n        }\n      }\n\n      .currency-converter {\n        .form-group {\n          position: relative;\n\n          img, svg {\n            position: absolute;\n            left: 1rem;\n            top: 50%;\n            transform: translateY(-50%);\n            height: 20px;\n            width: 20px;\n          }\n\n          input {\n            padding-left: 2.5rem;\n          }\n        }\n\n        span {\n          padding: 0 1rem;\n          color: var(--white);\n        }\n\n        button > span {\n          padding: 0;\n        }\n      }\n\n      .payment-left-card {\n        @media screen and (max-width: 767.98px) {\n          flex-direction: column;\n        }\n\n        h4 {\n          line-height: 1.6;\n          font-size: 1rem;\n          font-weight: 500;\n          margin-bottom: 0;\n          font-style: normal;\n          color: var(--gray-20);\n\n          @media screen and (max-width: 767.98px) {\n            margin-bottom: 1.5rem;\n          }\n        }\n      }\n\n      .payment-card-center {\n        display: flex;\n        align-items: center;\n\n        @media screen and (max-width: 767.98px) {\n          justify-content: center;\n        }\n\n        img, svg {\n          margin: 0 0.25rem;\n          max-width: 2.875rem;\n          max-height: 1.5rem;\n        }\n      }\n\n      .payment-card-right {\n        text-align: center;\n\n        button.btn-primary {\n          background-color: linear-gradient(#EFD43C, #CB7D00);\n          color: var(--gray-20);\n        }\n\n        .btn {\n          @media screen and (max-width: 600px) {\n            width: 100%;\n          }\n\n\n        }\n\n        @media screen and (max-width: 767.98px) {\n          margin-top: 1.5rem;\n        }\n      }\n    }\n\n    .bitcoin-instruction-list {\n      margin-top: 1.2rem;\n      margin-bottom: 0;\n\n      li {\n        font-size: 0.865rem;\n        font-weight: 500;\n      }\n    }\n\n    .modal-btn-wrap {\n      @media screen and (max-width: 767.98px) {\n        margin-top: 1rem;\n      }\n\n      .btn {\n        margin-left: 1rem;\n        line-height: 1rem;\n        height: 48px;\n\n        @media screen and (max-width: 767.98px) {\n          width: 100%;\n          margin-left: 0;\n          margin-bottom: 1rem;\n        }\n      }\n    }\n\n    .coupon-section {\n      text-align: center;\n      padding-bottom: 2rem;\n      padding-top: 0.5rem;\n      background-color: var(--gray-85);\n      border-radius: 8px;\n\n      @media screen and (max-width: 767.98px) {\n        height: 100%;\n        padding-top: 1.75rem;\n      }\n\n      img {\n        width: 8rem;\n        height: 8rem;\n        margin: 0 auto;\n      }\n\n      h4 {\n        color: var(--white);\n        font-weight: 700;\n        font-size: 1.25rem;\n        margin-bottom: 0 !important;\n      }\n\n      .form-group {\n        max-width: 220px;\n        margin: 1.25rem auto 1.5rem;\n      }\n\n      p {\n        color: var(--white);\n        font-weight: 500;\n\n        a {\n          color: var(--blue-300);\n          padding-left: 0.2rem;\n          display: inline-block;\n        }\n      }\n    }\n\n    .custom-tabs-nav {\n      width: calc(100% - 1.75rem);\n      margin-bottom: .5rem;\n\n      @media screen and (max-width: 767.98px) {\n        margin-bottom: 0;\n      }\n    }\n\n    .nav-pills {\n      @media screen and (max-width: 767.98px) {\n        flex-wrap: nowrap;\n        overflow-x: auto;\n        width: 100%;\n      }\n    }\n\n    .btn-info {\n      @media screen and (max-width: 767.98px) {\n        font-size: 0.75rem;\n      }\n    }\n\n    .modal-content {\n      height: 100%;\n    }\n  }\n\n  .error-msg {\n    margin: 0;\n    position: absolute;\n  }\n}\n\n.cashier-btn {\n  .nav {\n    gap: 0.75rem;\n\n    .nav-item {\n      .nav-link {\n        background-color: var(--gray-85);\n        border: 2px solid var(--gray-85);\n        border-radius: 0.625rem;\n        color: var(--gray-20);\n        font-size: 0.875rem;\n        font-weight: 600;\n        line-height: 1.75rem;\n        padding: 0.375rem 1.625rem;\n\n        &:hover {\n          background-color: var(--gray-60);\n          border: 2px solid var(--gray-60);\n          color: var(--blue-300);\n        }\n\n        &.active,\n        &.active:hover {\n          background-color: var(--gray-85);\n          border: 2px solid var(--blue-300);\n          color: var(--blue-300) !important;\n        }\n      }\n    }\n  }\n}\n\n.remove-blur {\n  backdrop-filter: blur(0) brightness(1);\n}\n\n.mob-reward-btn {\n  border: none !important;\n  background: var(--gray-80-50) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
